
/* jshint -W098 */
angular.module('mean.projects').controller('ProjectAdminController', ['$scope', '$http', '$state', 'Global', 'Customers', 'Projects', 'ProjectBids', 'MeanUser', 'Users', '$filter', '$timeout', 'ProjectTasks', 'ProjectJobs', 'Bids', 'Builders', 'Materials', 'Equipments', 'tradeCodeService', '$rootScope', '$q', 'userService', 'builderService', 'Trades', 'contactService', 'toaster', 'foremanPhaseService', 'aceUtils', 'lotScheduleService', 'Options', 'projectOptionService', 'TradeBids', 'taskTotalsService', 'bidTotalsService', 'ngDialog', 'projectCompleteService', '$location', 'updateMaterialColorService', 'HiddenItems', 'lotService', 'daysDifferenceService', 'optionService', 'optionPlanService', 'TradeOption', 'projectBidService', 'PrintOptions',
  function($scope, $http, $state, Global, Customers, Projects, ProjectBids, MeanUser, Users, $filter, $timeout, ProjectTasks, ProjectJobs, Bids, Builders, Materials, Equipments, tradeCodeService, $rootScope, $q, userService, builderService, Trades, contactService, toaster, foremanPhaseService, aceUtils, lotScheduleService, Options, projectOptionService, TradeBids, taskTotalsService, bidTotalsService, ngDialog, projectCompleteService, $location, updateMaterialColorService, HiddenItems, lotService, daysDifferenceService, optionService, optionPlanService, TradeOption, projectBidService, PrintOptions) {
    $scope.global = Global;
    $scope.package = {
      name: 'projectAdmin'
    }; 

    $scope.selectedProjectInformation = 0;
    $scope.original_tasks = [];
    $scope.selectedItemShow = false;

    $scope.lot_spreadsheet = [];
    $scope.cs_categories = [];
    $scope.project_tasks = [];
    $scope.matrix_values = [];
    $scope.options = {};
    $scope.trade_bids = [];
    $scope.bid = {}; //original bid
    $scope.dontResetLot = false;
    $scope.revisions = [];
    $scope.optionNameEditId = -1;
    $scope.loaded = false;
    $scope.plan_codes = [];
    $scope.savedOptionIndex = -1;
    $scope.show_spinner = false;

    $scope.selected_manager = {};
    $scope.selected_foreman = {};
    $scope.current_bid_revision = {};

    $scope.options.zoom = 1;
    $scope.options.layout = 'Task';
    $scope.bid_revisions_to_include = [];

    $scope.customers = [];
    $scope.selCustomer = '';
    $scope.selManager = '';
    $scope.selPAgent = '';
    $scope.is_service = false;

    $scope.headersFormats = {
        'year': 'YYYY', 
        'quarter': '[Q]Q YYYY', 
        month: 'MMMM YYYY', 
        week: 'w',
        day: 'DDD', 
        hour: 'H', 
        minute:'HH:mm'
    }

    $scope.customtask = {
        name: "Some task",
        classes: "custom-task"
    }

    $scope.tradeFilter = '';
    $scope.sortType = ['phase', 'number*1'];
    $scope.sortReverse = false;

    $scope.user = MeanUser.user;
    //$scope.original_bid_tasks = [];

    //var holidays = [];
    var dateFormat = 'yyyy-MM-dd';
    $scope.date_array = [];

    lotScheduleService.setHolidaysArray($scope.user.username);
    daysDifferenceService.setHolidaysArray($scope.user.username);

    $scope.$on('$updateOptionSubtask', function(event, data) {
        console.log('in the options addToBidOptions and have the project');
        $scope.trade_options = data;
        //$scope.changeProject();

        //need to add back the lot data to $scope.trade_options.options.lots
        $scope.buildCurrentOptions();

        $scope.matrix_values = optionPlanService.buildAndTotalPlans(
            $scope.trade_options.options,
            $scope.selectedItem.plan_codes, $scope.matrix_values, 
            $scope.trade_bids[0].bid_list, $scope.user.trade[0]);

        _.each($scope.ordered_lots, function(lot) {
            $scope.getOptionTotal(lot);
        });

        $scope.buildConsolidatedMaterials();
        //$scope.buildOptionMaterials();
        $scope.updateMaterialData(false);
    });

    $scope.$on('optionsFileLoaded', function(event, data) {
        _.each(data, function(opt) {
            var inlist = $filter('filter')($scope.trade_options.options, {
                'number': opt.number}, true);

            if(inlist.length === 0) {
                opt.bid_revision = $scope.revisions.length;
                opt.revisions = [{
                    number: 1 //first option revsision
                }]

                $scope.trade_options.options.push(opt);
            }
        });

        $scope.trade_options.$update(function(success) {
            $scope.trade_options = success;

            $scope.changeProject();
        }, function(error) {
            toaster.pop('error', 'Options Update Error', error);
            return;
        });
    });

    userService.getMainAccount($scope.user.username).then(function(account) {
        $scope.main_user_account = account;
    });

    $scope.lot_numbers = [];

    for(var i=1; i<1000; i++) {
        if(i < 10) {
            $scope.lot_numbers.push('00' + i);
        } else if(i < 100){
            $scope.lot_numbers.push('0' + i);
        } else {
            $scope.lot_numbers.push(i);
        }
    };

    $scope.phase_numbers = [];

    for(var i=0; i<1000; i++) {
        if(i < 10) {
            $scope.phase_numbers.push('00' + i);
        } else if(i < 100) {
            $scope.phase_numbers.push('0' + i);
        } else {
            $scope.phase_numbers.push(i);
        }
    };

    $scope.group_options = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
    'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    $scope.eEditable = -1;
    $scope.editId = 0;

    $scope.projects = [];
    $scope.project_admin_menu = [];
    $scope.current_menu = {};
    $scope.selectedItem = {};
    $scope.plan_menu = [];
    $scope.current_plan = {};
    $scope.tasks = []; //holds array of tasks with bid information
    $scope.bid_tasks = []; //bids by project
    $scope.my_roles = [];
    $scope.is_admin = false;
    $scope.is_contractor = false;
    $scope.is_division = false;
    $scope.is_manager = false;
    $scope.is_foreman = false;
    $scope.my_trade = {};
    $scope.filterPhase = null;
    $scope.filterLot = null;
    $scope.savedOptionCopy = {};
    $scope.main_account = null;
    $scope.print_options = null;

    $scope.user = MeanUser.user;
    $scope.my_roles = MeanUser.user.roles;

    $scope.is_admin = userService.isAdmin($scope.user);
    $scope.is_builder = builderService.isBuilder($scope.user.username);

    if($scope.is_builder)
      $scope.can_edit = true;
    else
      $scope.can_edit = false;

    $scope.is_manager = ($scope.user.roles.indexOf('tm') !== -1);
    $scope.is_foreman = ($scope.user.roles.indexOf('foreman') !== -1);

    $scope.data = [];
    var now = new Date();

    $scope.first_day = moment([now.getFullYear(), 0, 1]);
    $scope.current_day = moment([now.getFullYear(), 0, 1]);
    $scope.days_offset = 0;

    $scope.minDate = new Date();
    $scope.dateOptions = {
        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2030, 1, 20),
        showWeeks: false,
        startingDay: 0
    };

    PrintOptions.query({'trade': $scope.user.trade[0], 
        'company_code': $scope.user.contractor_code }, function(printOptions) {
        if(printOptions.length == 1) {
            $scope.print_options = printOptions[0];
            if($scope.print_options.work_order_options.order.length == 0 ||
                $scope.print_options.work_order_options.order.length == 13) {
                $scope.print_options.work_order_options.order = [{
                    label: "Form Header",
                    value: 0
                }, {
                    label: "Project Information",
                    value: 1
                }, {
                    label: "Contact Information",
                    value: 2
                }, {
                    label: "Lot Information",
                    value: 3
                }, {
                    label: "Labor",
                    value: 4
                }, {
                    label: "Material",
                    value: 5
                }, {
                    label: "Equipment",
                    value: 6
                }, {
                    label: "Schedule",
                    value: 7
                }, {
                    label: "Color Scheme",
                    value: 8
                }, {
                    label: "Options",
                    value: 9
                }, {
                    label: "Notes",
                    value: 10
                }, {
                    label: "Page Break",
                    value: 11
                }, {
                    label: "Page Break",
                    value: 12
                }, {
                    label: "Page Break",
                    value: 13
                }]

                $scope.print_options.$update(function(success) {
                    $scope.print_options = success[0];
                }, function(error) {
                    toaster.pop('error', 'Print Options Save Error')
                });
            }
        } else if(printOptions.length == 0) {
            var options = new PrintOptions({
                trade: $scope.user.trade[0],
                company_code: $scope.user.contractor_code,
                work_order_options: {
                    order: [{
                        label: "Form Header",
                        value: 0
                    }, {
                        label: "Project Information",
                        value: 1
                    }, {
                        label: "Contact Information",
                        value: 2
                    }, {
                        label: "Lot Information",
                        value: 3
                    }, {
                        label: "Labor",
                        value: 4
                    }, {
                        label: "Material",
                        value: 5
                    }, {
                        label: "Equipment",
                        value: 6
                    }, {
                        label: "Schedule",
                        value: 7
                    }, {
                        label: "Color Scheme",
                        value: 8
                    }, {
                        label: "Options",
                        value: 9
                    }, {
                        label: "Notes",
                        value: 10
                    }, {
                        label: "Page Break",
                        value: 11
                    }, {
                        label: "Page Break",
                        value: 12
                    }, {
                        label: "Page Break",
                        value: 13
                    }]
                }
            });

            options.$save(function(success) {
                $scope.print_options = success[0];
            }, function(error) {
                toaster.pop('error', 'Print Options Save Error')
            });
        }
    });

    function disabled(data) {
        return lotScheduleService.disabled(data.date, data.mode);
    };

    $scope.init = function() {
        $scope.trades_array = tradeCodeService.getArray();

        if($scope.is_builder) {
            Users.query({'roles': 'tm'}, function(users) {
                $scope.tm_users = users;
            });
            userService.getMainAccount($scope.user.username).then(function(main_account) {
                $scope.main_account = main_account;
                Builders.query({'builder': $scope.main_account._id}, function(builders) {
                    $scope.builders = builders;
                    $scope.selectedBuilder = builders[0];

                    Projects.query({'trade_code': userService.getTradeCode(MeanUser.user.username), 
                    'company_code': userService.getCompanyCode(MeanUser.user.username), 
                    'complete': false }, function(projects) {
                        $scope.projects = projects;
                    });
                });
                // get customer list
                Customers.query({'isDeleted': false, 'userId': $scope.main_account._id},
                function(results) {
                    $scope.customers = results;
                });
            });
        } else {
            Users.query({'trade': $scope.user.trade[0], 'contractor_code': $scope.user.contractor_code}, function(users) {
                $scope.tm_users = $filter('filter')(users, { roles: 'tm' }, true);
                $scope.foreman_users = $filter('filter')(users, { roles: 'foreman' }, true);
            });
            userService.getMainAccountId($scope.user.username).then(function(id) {
                $scope.main_account = id;
                contactService.getMyContacts(id).then(function(contacts) {
                    $scope.builders = [];

                    Trades.query({'main_account_id': id}, function(trade) {
                        if(trade.length === 0) return;

                        trade[0].company_code =
                            aceUtils.padDigits(trade[0].company_code, 3);
                        trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                        $scope.builders.push(trade[0]);
                        $scope.my_trade = trade[0];
                    });

                    contacts.builders.forEach(function(builder) {
                        Builders.query({'builder': builder._id}, function(builders) {
                            if(builders.length === 0) return;
                            builders[0].company_code =
                                aceUtils.padDigits(builders[0].company_code, 3);
                            builders[0].trade_code = '00';
                            $scope.builders.push(builders[0]);
                        });
                    });
                    // get customer list
                    Customers.query({'isDeleted': false, 'userId': id}, function(results) {
                        $scope.customers = results;
                    });
                });
            });
        }

        $scope.project_admin_menu.push({
            item: 'Lots Information'
        });
        $scope.project_admin_menu.push({
            item: 'Project Information'
        });
        $scope.project_admin_menu.push({
            item: 'Trades Information'
        });
        $scope.project_admin_menu.push({
            item: 'Schedule'
        });
        $scope.project_admin_menu.push({
            item: 'Task List'
        });
        $scope.project_admin_menu.push({
            item: 'Template Task Chart'
        });
        $scope.project_admin_menu.push({
            item: 'Color Scheme'
        });
        // $scope.project_admin_menu.push({
        //     item: 'Documents'
        // });
         $scope.project_admin_menu.push({
            item: 'Options'
        });

        $scope.current_menu = $scope.project_admin_menu[0];
    };

    $scope.setSelectedBuilderOption = function() {
        console.log("$scope.bid", $scope.bid);
        $scope.selCustomer = !_.isEmpty($scope.bid.selCustomer) ? $scope.bid.selCustomer.name : '';
        if (!_.isEmpty($scope.bid.selCustomer) && $scope.bid['project_manager_info'] && $scope.bid.selCustomer.contacts.projectManagers.length) {
            const foundManager = $scope.bid.selCustomer.contacts.projectManagers.filter(item => item.name === $scope.bid['project_manager_info']['name']);
            if (foundManager.length) {
                $scope.selManager = foundManager[0].name;
            }
        }

        if (!_.isEmpty($scope.bid.selCustomer) && $scope.bid['purchasing_agent_info'] && $scope.bid.selCustomer.contacts.purchasingAgents.length) {
            const foundAgent = $scope.bid.selCustomer.contacts.purchasingAgents.filter(item => item.name === $scope.bid['purchasing_agent_info']['name']);
            if (foundAgent.length) {
                $scope.selPAgent = foundAgent[0].name;
            }
        }
    }

    $scope.importPAgent = function(selPAgent) {
        if (!selPAgent) return;
        const selCust  = $scope.bid.selCustomer.contacts.purchasingAgents.filter(item => item.name === selPAgent);
        if(selCust.length) {
            $scope.bid['purchasing_agent_info'] = {};
            $scope.bid['purchasing_agent_info']['name'] = selCust[0].name;
            $scope.bid['purchasing_agent_info']['phone'] = selCust[0].phone;
            $scope.bid['purchasing_agent_info']['email'] = selCust[0].email;

            !$scope.selectedItem.hasOwnProperty('contact') && ($scope.selectedItem['contact'] = {});
            $scope.selectedItem['contact']['name'] = selCust[0].name;
            $scope.selectedItem['contact']['phone'] = selCust[0].phone;
            $scope.selectedItem['contact']['email'] = selCust[0].email;
        }
    }

    $scope.importProjectManager = function(selManager) {
        if (!selManager) return;
        const selCust  = $scope.bid.selCustomer.contacts.projectManagers.filter(item => item.name === selManager);
        if(selCust.length) {
            $scope.bid['project_manager_info'] = {};
            $scope.bid['project_manager_info']['name'] = selCust[0].name;
            $scope.bid['project_manager_info']['phone'] = selCust[0].phone;
            $scope.bid['project_manager_info']['email'] = selCust[0].email;

            !$scope.selectedItem.hasOwnProperty('mtc') && ($scope.selectedItem['mtc'] = {});
            $scope.selectedItem['mtc']['division_manager_name'] = selCust[0].name;
            $scope.selectedItem['mtc']['division_manager_phone_number'] = selCust[0].phone;
            $scope.selectedItem['mtc']['division_manager_email'] = selCust[0].email;
        }
    }

    $scope.importCustomer = function(selCustomer) {
        if (!selCustomer) return;
        const selCust  = $scope.customers.filter(item => item.name === selCustomer);
        $scope.bid['selCustomer'] = selCust[0];
        if (selCust.length && !$scope.bid.hasOwnProperty('selCustomer')) {
            $scope.bid['builder_info'] = {};
            $scope.bid['builder_info']['address_one'] = selCust[0].address.street;
            $scope.bid['builder_info']['city'] = selCust[0].address.city;
            $scope.bid['builder_info']['email'] = selCust[0].email;
            $scope.bid['builder_info']['name'] = selCust[0].name;
            $scope.bid['builder_info']['phone'] = selCust[0].phone;
            $scope.bid['builder_info']['state'] = selCust[0].address.state;
            $scope.bid['builder_info']['zip'] = selCust[0].address.zipCode;
            $scope.bid['builder_info']['address_two'] = '';
        }
        if(selCust.length) {
            !$scope.selectedItem.hasOwnProperty('builder') && ($scope.selectedItem['builder'] = {});
            $scope.selectedItem['builder']['address_one'] = selCust[0].address.street;
            $scope.selectedItem['builder']['address_two'] = '';
            $scope.selectedItem['builder']['email'] = selCust[0].email;
            $scope.selectedItem['builder']['name'] = selCust[0].name;
            $scope.selectedItem['builder']['city'] = selCust[0].address.city;
            $scope.selectedItem['builder']['phone'] = selCust[0].phone;
            $scope.selectedItem['builder']['state'] = selCust[0].address.state;
            $scope.selectedItem['builder']['zip'] = selCust[0].address.zipCode;
        }

    }

    $scope.changeBuilder = function(builder) {
        $scope.projects = [];
        $scope.selectedItemShow = false;

        if($scope.is_admin && !$scope.is_builder && this.selectedBuilder.trade) {
            $scope.can_edit = true;
        } else {
            $scope.can_edit = false;
        }

        if($scope.is_admin && $scope.is_builder) {
            //I want to see all the projects
            Projects.query({
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false }, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;

                if($state.params.selectedItem) {
                    $scope.selectedItem = $state.params.selectedItem;
                    $scope.$parent.selectedItem = $state.params.selectedItem;
                    $scope.changeProject($scope.selectedItem);
                }
            });
        } else if($scope.is_admin && !$scope.is_builder) {
            userService.getMainAccount($scope.user.username).then(function(user) {
                var match_string = '{ "trades.main_username": ' + user.username + '}';
                Projects.query({
                      'company_code': $scope.selectedBuilder.company_code,
                      'trade_code': $scope.selectedBuilder.trade_code,
                      'complete': false,
                      'match_string': true,
                      'username': user.username }
                      , function(projects) {
                    $scope.projects = projects;

                    if($state.params.selectedItem) {
                        $scope.selectedItem = $state.params.selectedItem;
                        $scope.$parent.selectedItem = $state.params.selectedItem;
                        $scope.changeProject($scope.selectedItem);
                    }
                });
            });
        } else if($scope.is_division) {
            //I want to see all of my contracted projects
            Projects.query({
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false,
                'mtc.division_manager_name': MeanUser.user.name}, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;

                if($state.params.selectedItem) {
                    $scope.selectedItem = $state.params.selectedItem;
                    $scope.$parent.selectedItem = $state.params.selectedItem;
                    $scope.changeProject($scope.selectedItem);
                }
            });
        } else if($scope.is_manager) {
            Projects.query({
                'type': 'findManagerProjects',
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false,
                'manager': MeanUser.user.username }, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;

                if($state.params.selectedItem) {
                    $scope.selectedItem = $state.params.selectedItem;
                    $scope.$parent.selectedItem = $state.params.selectedItem;
                    $scope.changeProject($scope.selectedItem);
                }
            });
        } else if($scope.is_foreman) {
            Projects.query({
                'type': 'findForemanProjects',
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false,
                'foreman': MeanUser.user.username }, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;

                if($state.params.selectedItem) {
                    $scope.selectedItem = $state.params.selectedItem;
                    $scope.$parent.selectedItem = $state.params.selectedItem;
                    $scope.changeProject($scope.selectedItem);
                }
            });
        } else {
            Projects.query({
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false }, function(projects) {
                if(projects.length === 0) return;

                $scope.projects = projects;

                if($state.params.selectedItem) {
                    $scope.selectedItem = $state.params.selectedItem;
                    $scope.$parent.selectedItem = $state.params.selectedItem;
                    $scope.changeProject($scope.selectedItem);
                }
            });
        }
    };

    if($state.params.selectedBuilder) {
        $scope.selectedBuilder = $state.params.selectedBuilder;
        $scope.$parent.selectedBuilder = $state.params.selectedBuilder;
        $scope.changeBuilder($state.params.selectedBuilder);
    }

    $scope.updateGantt = function(ordered_tasks) {
        $scope.data = [];

        ordered_tasks.forEach(function(task) {
            if($scope.tradeFilter !== '' && task.trade !== $scope.tradeFilter) {
                console.log('does not match the trade filter');
                return;
            } 

            var tmp_task = $filter('filter')($scope.selectedItem.trades, {
                name: $scope.getTradeString(task.trade)}, true);

            if($scope.options.layout === 'Trade') {
                var trade = $filter('filter')($scope.data, {
                    ame: $scope.getTradeString(task.trade)}, true);

                if(trade.length > 1) {
                    alert('Problem with the trade list');
                }
            }

            var end_date = moment($scope.first_day);
            var start_date = moment($scope.first_day);
            var color_option = {};

            start_date.add(task.days_offset, 'days');
            end_date.add(task.days_offset + task.days -1, 'days');

            if(tmp_task.length === 0) {
                color_option = '#9FC5F8';
            } else {
                color_option = '#93C47D';
            }

            if($scope.options.layout === 'Trade') {
                if(trade.length === 0) {
                    $scope.data.push({
                        name: $scope.getTradeString(task.trade),
                        tasks: [{
                            name: task.trade + task.task + ': ' + task.name,
                            data: {
                                id: task._id,
                                order: task.order,
                                trade: task.trade,
                                task: task.task
                            },
                            color: color_option,
                            from: new Date(start_date.year(), start_date.month(), start_date.date(), 0, 0, 0),
                            to: new Date(end_date.year(), end_date.month(), end_date.date(), 24, 0, 0)
                        }]
                    });
                } else {
                    trade[0].tasks.push({
                        name: task.trade + task.task + ': ' + task.name,
                        data: {
                            id: task._id,
                            order: task.order,
                            trade: task.trade,
                            task: task.task
                        },
                        color: color_option,
                        from: new Date(start_date.year(), start_date.month(), start_date.date(), 0, 0, 0),
                        to: new Date(end_date.year(), end_date.month(), end_date.date(), 24, 0, 0)
                    });
                }
            } else {
                //organize gantt chart by task
                $scope.data.push({
                    name: task.trade + task.task + ': ' + task.name,
                    trade: $scope.getTradeString(task.trade),
                    tasks: [{
                        name: task.trade + task.task + ': ' + task.name,
                        data: {
                            id: task._id,
                            order: task.order,
                            trade: task.trade,
                            task: task.task
                        },
                        color: color_option,
                        from: new Date(start_date.year(), start_date.month(), start_date.date(), 0, 0, 0),
                        to: new Date(end_date.year(), end_date.month(), end_date.date(), 24, 0, 0)
                    }]
                });
            }
        });
    };

    $scope.filterData = function() {
        //console.log('in filterData');
        if(this.tradeFilter)
          $scope.tradeFilter = this.tradeFilter.value;
        else
          $scope.tradeFilter = '';

        var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'order', false);
        $scope.updateGantt(ordered_tasks);
    };

    $scope.filterData2 = function() {
        //console.log('in filterData');
        if(this.tradeFilter)
          $scope.tradeFilter = this.tradeFilter;
        else
          $scope.tradeFilter = '';
    };

    $scope.changeLayout = function() {
        var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'order', false);
        $scope.updateGantt(ordered_tasks);
    };

    function UniqueArraybyKey(collection, keyname) {
        var output = [], 
        keys = [];

        _.each(collection, function(item) {
          var key = item[keyname];
          if(keys.indexOf(key) === -1) {
              keys.push(key);
              output.push(item);
          }
        });

        return output;
    };

    $scope.updateRevisions = function(project) {
        $scope.revisions = [];

        if(project.trades.length !== 1) {
            toaster.pop('error', 'Project Trade Error', 'Contact Admin');
            return;
        } else {
            _.each(project.trades[0].revisions, function(rev) {
                $scope.revisions.push({
                    name: 'Rev: ' + rev.number,
                    number: rev.number
                });
            });

            $scope.revisions.push({
                name: 'Current',
                number: $scope.revisions.length+1
            });
        }

        $scope.selectedRevision = $scope.revisions[$scope.revisions.length-1];
        $scope.totalRevisionLength = $scope.revisions.length;
    };

    $scope.normalizeLotRevisions = function() {
        _.each($scope.selectedItem.lots, function(lot) {
            var rev = $filter('filter')(lot.revisions, {'trade': $scope.user.trade[0]}, true);
            if(rev.length === 0) {
                //lot.revision = 1;
            } else if(rev.length === 1) {
                lot.revision = rev[0].revision;
            } else {
                toaster.pop('error', 'Lot Revision Error', 'Contact Admin');
            }
        });
    };

    $scope.changeProject = function(proj) {
        if(!this.selectedItem) {
            console.log('selectedItem is null...returning.', this.selectedItem);
            return;
        }

        $scope.loaded = false;
        $scope.selectedItemShow = true;

        if(this.selectedItem.geoLocation == 'Service' && this.selectedItem.projectType == 'Service') {
            $scope.is_service = true;
        } else {
            $scope.is_service = false;
        }

        $scope.plan_codes = []; //angular.copy(this.selectedItem.plan_codes);
        _.each(this.selectedItem.plan_codes, function(plan) {
            $scope.plan_codes.push(plan.item);
        });

        _.each(this.selectedItem.lots, function(lot) {
            _.each(lot.active_options, function(option) {
                if(option.number)
                  option.number = option.number.trim();
                if(option.name)
                  option.name = option.name.trim();
            });
        });

        this.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $rootScope.$broadcast('$changeProjectInformationTab', proj);

            $scope.onSelect($scope.project_admin_menu[0]);

            $scope.matrix_values = [];
            $scope.ordered_lots = [];
            $scope.bid_tasks = [];
            $scope.plans = [];
            $scope.original_bid_subtasks = [];
            $scope.bid = {};
            $scope.trade_options = {};

            console.log('In projectAdmin changeProject');

            var geocoder = new google.maps.Geocoder();
          
            geocoder.geocode( { 'address' : $scope.selectedItem.contact.address_one + " " + $scope.selectedItem.contact.city + " " + $scope.selectedItem.contact.state }, function( results, status ) {
                if (status == 'OK') {
                    $scope.selectedItem.contact.lat = results[0].geometry.location.lat();
                    $scope.selectedItem.contact.lng = results[0].geometry.location.lng();
                }
            });

            $scope.normalizeLotRevisions();

            $scope.updateRevisions($scope.selectedItem);

            var inlist = $filter('filter')($scope.selectedItem.plan_codes, {'item': 'T&M'}, true);
            if(inlist.length === 0) {
                $scope.selectedItem.plan_codes.push({
                    item: 'T&M'
                });
            } else if(inlist.length > 1) {
                _.remove($scope.selectedItem.plan_codes, function(plan) {
                    return plan.item === 'T&M';
                });
                $scope.selectedItem.plan_codes.push({
                    item: 'T&M'
                });
            }

            _.each($scope.selectedItem.plan_codes, function(plan) {
                $scope.plans.push(plan.item);
            });

            $scope.projectType = $scope.selectedItem.projectType + '('+ $scope.selectedItem.geoLocation + ')';

            $rootScope.$broadcast("projectSelectionUpdated", { selectedItem: $scope.selectedItem });

            if($scope.current_menu.item === 'Template Task Chart') {
                var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'order', false);
                $scope.updateGantt(ordered_tasks);
            }

            $scope.ordered_lots = [];
            //$scope.ordered_lots = $filter('orderBy')($scope.selectedItem.lots, ['phase', 'number']);
            $scope.ordered_lots = $scope.selectedItem.lots;
            $scope.trade_bids = [];

            if($scope.is_builder) {
                ProjectTasks.query({'project_id': $scope.selectedItem._id,
                    'complete': false,
                    'company_code': userService.getCompanyCode(MeanUser.user.username),
                    'trade_code': userService.getTradeCode(MeanUser.user.username) }, function(tasks) {

                        $scope.project_tasks = tasks;

                    Options.query({ 'type': 'TradeProjectOptions',
                        'trade_id': $scope.my_trade._id,
                        'project_id': $scope.selectedItem._id}, function(options) {
                        //$scope.trade_options = options;
                        var test_opts = [];
                        if(options.length === 0) {
                            toaster.pop('warning', 'Options', 'Did not find any options for this project');
                            //return;
                        } else if(options.length > 1) {
                            toaster.pop('error', 'Options', 'Did not get the expected number of options');
                            return;
                        } else {
                            _.each(options[0].options, function(opt) {
                                var to = new TradeOption(opt.number);
                                test_opts.push(to);
                                console.log('Pushed Trade Option (' + to.getNumber() + ') to test list.');
                            });
                            $scope.trade_options = options[0];
                            if(aceUtils.isUndefinedOrZero(options[0].bid_id)) {
                                toaster.pop('warning', 'Associated Bid', 'No bid found for this option.');
                                //this search will get all bids assigned to me.  might try this
                                //to get a list and then let the user select the bid that should
                                //be associated with this option.
                                // Bids.query({'type': 'UserBids', 'username': $scope.user.username}, function(bids) {

                                // });
                            } else {
                                Bids.query({'_id': $scope.trade_options.bid_id}, function(bids) {
                                    if(bids.length !== 1) {
                                        toaster.pop('error', 'Original Bid', 
                                            'Did not get back the correct number of bids.  Contact admin.');
                                        return;
                                    } else {
                                        $scope.bid = bids[0];
                                        $scope.setSelectedBuilderOption();
                                    }

                                    $scope.bid.bidding_trades.forEach(function(trade) {
                                        trade.bid_list = taskTotalsService.mergeBidAndTaskList(
                                            $scope.plans, 
                                            tradeCodeService.getCode($scope.user.trade[0]), 
                                            trade);

                                        taskTotalsService.getCalculations(
                                            trade.bid_list, 
                                            trade.costs);

                                        $scope.trade_bids.push(trade);
                                    });

                                    $scope.matrix_values = optionPlanService.buildAndTotalPlans(
                                        $scope.trade_options.options,
                                        $scope.selectedItem.plan_codes, $scope.matrix_values, 
                                        $scope.trade_bids[0].bid_list, $scope.user.trade[0]);

                                    $scope.buildCurrentOptions();

                                    _.each($scope.ordered_lots, function(lot) {
                                        $scope.getOptionTotal(lot);
                                    })
                                });
                            }
                        }
                    });

                    ProjectBids.query({
                        'project_id':$scope.selectedItem._id, 
                        'trade': MeanUser.user.trade[0],
                        'complete': false }, function(bid_tasks) {
                        $scope.bid_tasks = bid_tasks;
                        //$scope.original_bid_tasks = angular.copy($scope.bid_tasks);

                        $scope.plan_menu = [];

                        $scope.plan_menu.push({
                            item: 'Standard'
                        });

                        if(!$scope.selectedItem.trades[0].color_scheme_codes) {
                            $scope.selectedItem.trades[0].color_scheme_codes = [];
                        }

                        $scope.cs_categories = $scope.selectedItem.trades[0].color_scheme_codes;

                        $scope.buildConsolidatedMaterials();
                        //$scope.buildOptionMaterials();
                        $scope.updateMaterialData(true);

                        // for(var i=0; i<$scope.consolidated_materials.length; i++) {
                        //     var mat = $scope.consolidated_materials[i];
                        //     mat.lots = [];
                        //     for(var j=0; j<$scope.ordered_lots.length; j++) {
                        //         var lot = $scope.ordered_lots[j];
                        //         var val = {
                        //             number: lot.number,
                        //             current: $scope.getMaterialColorCode(mat, lot),
                        //             color_scheme: lot.color_scheme,
                        //             phase: lot.phase,
                        //             plan: lot.plan
                        //         }

                        //         mat.lots.splice(j, 0, val);
                        //     }
                        // }

                        $scope.plan_menu.push({
                            item: 'Plans Tab'
                        });
                        $scope.current_plan = $scope.plan_menu[0];
                        $scope.onPlanSelect($scope.current_plan);
                    });
                });
            } else {
                 ProjectTasks.query({'project_id': $scope.selectedItem._id,
                    'trade': MeanUser.user.trade[0],
                    'complete': false,
                    'company_code': userService.getCompanyCode(MeanUser.user.username),
                    'trade_code': userService.getTradeCode(MeanUser.user.username) }, function(tasks) {

                        $scope.project_tasks = tasks;

                    Options.query({ 'type': 'TradeProjectOptions',
                        'trade_id': $scope.my_trade._id,
                        'project_id': $scope.selectedItem._id}, function(options) {
                        
                        if(options.length === 0) {
                            toaster.pop('warning', 'Options', 'Did not find any options for this project');
                            //return;
                        } else if(options.length > 1) {
                            toaster.pop('error', 'Options', 'Did not get the expected number of options');
                            return;
                        } else {

                            $scope.trade_options = options[0];

                            //we don't want to build all available bid revisions so
                            //lets just build the ones options are based off of
                            $scope.bid_revisions_to_include = [];
                            var bid_rev_return = $filter('unique')($scope.trade_options.options, 'bid_revision');

                            _.each(bid_rev_return, function(rev) {
                                $scope.bid_revisions_to_include.push(rev.bid_revision);
                            });
                                

                            if(aceUtils.isUndefinedOrZero(options[0].bid_id)) {
                                toaster.pop('warning', 'Associated Bid', 'No bid found for this option.');
                                //this search will get all bids assigned to me.  might try this
                                //to get a list and then let the user select the bid that should
                                //be associated with this option.
                                // Bids.query({'type': 'UserBids', 'username': $scope.user.username}, function(bids) {

                                // });
                            } else {
                                Bids.query({'_id': $scope.trade_options.bid_id}, function(bids) {
                                    if(bids.length !== 1) {
                                        toaster.pop('error', 'Original Bid', 
                                            'Did not get back the correct number of bids.  Contact admin.');
                                        return;
                                    } else {
                                        $scope.bid = bids[0];
                                        $scope.setSelectedBuilderOption();
                                    }

                                    //this is getting the calculations by plan
                                    _.each($scope.bid.bidding_trades, function(trade) {
                                        trade.bid_list = taskTotalsService.mergeBidAndTaskList(
                                            $scope.plans, 
                                            tradeCodeService.getCode($scope.user.trade[0]), 
                                            trade,
                                            $scope.bid_revisions_to_include);

                                        taskTotalsService.getCalculations(
                                            trade.bid_list, 
                                            trade.costs);

                                        $scope.trade_bids.push(trade);
                                    });

                                    $scope.matrix_values = optionPlanService.buildAndTotalPlans(
                                        $scope.trade_options.options,
                                        $scope.selectedItem.plan_codes, $scope.matrix_values, 
                                        $scope.trade_bids[0].bid_list, $scope.user.trade[0]);


                                    $scope.buildCurrentOptions();

                                    _.each($scope.ordered_lots, function(lot) {
                                        $scope.getOptionTotal(lot);
                                    });

                                    $scope.loaded = true;
                                });
                            }
                        }
                    });

                    ProjectBids.query({
                        'project_id':$scope.selectedItem._id, 
                        'trade': MeanUser.user.trade[0],
                        'complete': false }, function(bid_tasks) {

                        if(bid_tasks.length === 0) {
                            toaster.pop('error', 'Project Bids Revision Error', 
                                'Project Bids have a revision issue. To correct please go to Bid Control Center.  Click the Review button.  In the review mode, click the Regenerate button to refresh the bids associated with this project.');
                        }
                        $scope.bid_tasks = bid_tasks;

                        HiddenItems.query({
                            'project_id': $scope.selectedItem._id, 
                            'company_code': userService.getCompanyCode(MeanUser.user.username),
                            'trade_code': userService.getTradeCode(MeanUser.user.username) }, function(hidden_items) {
                            
                            if(hidden_items.length > 1) {
                                toaster.pop('error', 'Hidden Items DB Error', 
                                    'Too many database entries.  Contact admin.');
                                return;
                            }

                            $scope.hidden_items = hidden_items[0];
                            $scope.plan_menu = [];

                            $scope.plan_menu.push({
                                item: 'Standard'
                            });

                            if(!$scope.selectedItem.trades[0].color_scheme_codes) {
                                $scope.selectedItem.trades[0].color_scheme_codes = [];
                            }

                            $scope.cs_categories = $scope.selectedItem.trades[0].color_scheme_codes;

                            $scope.buildConsolidatedMaterials();
                            $scope.updateMaterialData(true);

                            //we don't have a db entry so lets create one
                            if(hidden_items.length === 0) {
                                var hidden = new HiddenItems({
                                    trade_code: userService.getTradeCode(MeanUser.user.username),
                                    company_code: userService.getCompanyCode(MeanUser.user.username),
                                    project_id: $scope.selectedItem._id
                                });

                                hidden.$save(function(success) {
                                    $scope.hidden_items = success;
                                }, function(error) {
                                    toaster.pop('error', 'Hidden Items Save Error', error);
                                });
                            }   

                            $scope.plan_menu.push({
                                item: 'Plans Tab'
                            });
                            $scope.current_plan = $scope.plan_menu[0];
                            $scope.onPlanSelect($scope.current_plan);

                            $scope.loaded = true;
                        });
                    });
                });
            }
        }, function(error) {
            toaster.pop('error', 'Trimming Option Number Error', error);
        });
    };

    $scope.buildConsolidatedMaterials = function() {
        $scope.materials = [];
        $scope.consolidated_materials = [];

        //order bid tasks by task code first
        $scope.bid_tasks = $filter('orderBy')($scope.bid_tasks, 'task_code');

        _.each($scope.bid_tasks, function(bid_task) {
            bid_task.materials = 
                $filter('orderBy')(
                    bid_task.materials, ['name', 'note']);

            _.each(bid_task.materials, function(material) {
                //add the task code to the material for the view
                material.task_code = bid_task.task_code;
                material.categories = [];
                _.each($scope.cs_categories, function(cat) {
                    var color = $filter('filter')(material.color_scheme, {
                        'category': cat.name }, true);
                    
                    if(color.length === 1) {
                        material.categories.push(color[0]);
                    } else if(color.length === 0) {
                        material.categories.push({
                            'category': cat.name
                        });
                    } else {
                        console.log('this should not be happening');
                    }
                });

                $scope.materials.push(material);
                var inlist = $filter('filter')($scope.consolidated_materials, {
                    'name': material.name, 
                    'supplier': material.supplier,
                    'note': material.note }, true);

                if(inlist.length === 0 && 
                    material.quantity !== 0) {
                    $scope.consolidated_materials.push(
                        angular.copy(material));
                }
            });
        });

        $scope.buildOptionMaterials();
    };

    $scope.buildOptionMaterials = function() {
        $scope.option_materials = [];

        _.each($scope.trade_options.options, function(option) {
            _.each(option.subtasks, function(subtask) {
                _.each(subtask.materials, function(material) {
                    //i don't remember why the isUndefined check was
                    //put here and I don't think it needs to be.
                    //commenting out for now just in cause i'm being stupid
                    //if(angular.isUndefined(material.material_id)) {

                        //add task code to the material
                        material.task_code = subtask.code;

                        material.categories = [];
                        _.each($scope.cs_categories, function(cat) {
                            var color = $filter('filter')(material.color_scheme, {
                                'category': cat.name }, true);
                            
                            if(color.length === 1) {
                                material.categories.push(color[0]);
                            } else if(color.length === 0) {
                                material.categories.push({
                                    'category': cat.name
                                });
                            } else {
                                console.log('this should not be happening');
                            }
                        });

                        $scope.materials.push(material);

                        var inlist = $filter('filter')($scope.consolidated_materials, {
                            'name': material.name,  
                            'supplier': material.supplier,
                            'note': material.note }, true);

                        if(inlist.length === 0 && 
                            material.quantity_allowed !== 0) {
                            $scope.consolidated_materials.push(material);
                        }
                    //}
                });
            });
        });

        $scope.consolidated_materials = 
            $filter('orderBy')($scope.consolidated_materials, ['task_code', 'name', 'note']);
    };

    $scope.updateMaterialData = function(color_info) {
        for(var i=0; i<$scope.consolidated_materials.length; i++) {
            var mat = $scope.consolidated_materials[i];
            if(color_info) {
                mat.lots = [];
                for(var j=0; j<$scope.ordered_lots.length; j++) {
                    var lot = $scope.ordered_lots[j];
                    var val = {
                        number: lot.number,
                        current: $scope.getMaterialColorCode(mat, lot),
                        color_scheme: lot.color_scheme,
                        phase: lot.phase,
                        plan: lot.plan
                    }

                    mat.lots.splice(j, 0, val);
                }
            }

            if($scope.hidden_items && $scope.hidden_items.items.length > 0) {
                var inlist = $filter('filter')($scope.hidden_items.items, {
                    'name': mat.name,
                    'note': mat.note }, true);
                if(inlist.length === 1) {
                    mat.toggle = inlist[0].toggle;
                } else {
                    mat.toggle = false;
                }
            } else {
                mat.toggle = false;
            }
        }
    };

    $scope.toggleFilter = function(item) {
        item.toggle = !item.toggle;

        var inlist = $filter('filter')($scope.hidden_items.items, {
            'name': item.name, 'note': item.note }, true);

        if(inlist.length === 1) {
            inlist[0].toggle = item.toggle;
        } else {
            $scope.hidden_items.items.push({
                'name': item.name,
                'note': item.note,
                'toggle': item.toggle
            });
        }

        $scope.hidden_items.$update();
    };

    $scope.clearHiddenMaterials = function() {
        _.each($scope.consolidated_materials, function(item) {
            item.toggle = false;
        });

        // _.each($scope.option_materials, function(item) {
        //     item.toggle = false;
        // });

        _.each($scope.hidden_items.items, function(item) {
            item.toggle = false;
        });
        $scope.hidden_items.$update();
    };

    $scope.onSelect = function(item) {
        $scope.current_menu = item;

        if(item.item === 'Template Task Chart') {
            var ordered_tasks = $filter('orderBy')($scope.selectedItem.plan[0].task_list, 'order', false);
            $scope.updateGantt(ordered_tasks);
        } else if(item.item === 'Task List') {
            $scope.onPlanSelect($scope.current_plan);
        }
    };

    $scope.editTradeInfo = function(item) {
        $scope.available_managers = [];
        $scope.can_modify_trade = true;

        if(item.name !== $scope.user.trade[0]) {
            toaster.pop('warning', 'Trade', 'You cannot modify this entry');
            $scope.can_modify_trade = false;
            return;
        }

        $scope.current_selected_trade = item.name;

        $scope.available_managers = $scope.tm_users;
        $scope.available_foremen = $scope.foreman_users;

        $scope.new_manager = {};
        $scope.new_foreman = {};
    };

    $scope.acceptTradeEdits = function() {
        console.log(this);
        var trade = $filter('filter')(this.selectedItem.trades, {'name': $scope.current_selected_trade}, true);
        if(trade.length !== 1) {
            alert('Problem getting the trade ' + $scope.current_selected_trade + ' from the project info');
            return;
        }

        if(this.new_foreman && this.new_foreman.name) {
            trade[0].foreman = {
                email: this.new_foreman.email,
                name: this.new_foreman.name,
                phone: this.new_foreman.phone,
                username: this.new_foreman.username
            }
        }

        //we only need to update the tasks that are not
        //designated to another management combination
        $scope.available_tasks = $filter('filter')($scope.tasks, {
            'trade': tradeCodeService.getCode(trade[0].name)}, true);

        var tasks_to_update = [];
        _.each($scope.available_tasks, function(task) {
            tasks_to_update.push(task.trade + task.task);
        });

        _.each(trade[0].management_combinations, function(manCombo) {
            _.each(manCombo.tasks, function(task) {
                _.remove(tasks_to_update, function(n) {
                    return n === task.code;
                });
            });
        });

        if(this.new_manager && this.new_manager.name) {
            trade[0].manager.email = this.new_manager.email;
            trade[0].manager.name = this.new_manager.name;
            trade[0].manager.phone = this.new_manager.phone;
            trade[0].manager.username = this.new_manager.username;

            $scope.selectedItem = this.selectedItem;
            $scope.new_manager = this.new_manager;
            $scope.new_foreman = this.new_foreman;

            //Find the scheduled tasks and update those as well. managers only
            ProjectTasks.query({'project_id': $scope.selectedItem._id,
                    'complete': false,
                    'trade': $scope.user.trade[0]}, function(tasks) {

                //remove the tasks designated for other management combos
                _.remove(tasks, function(n) {
                    return tasks_to_update.indexOf(n.task_code) === -1;
                });

                for(var i=0; i<tasks.length; i++) {
                    tasks[i].foreman = $scope.new_foreman;
                    tasks[i].trade_manager_id = $scope.new_manager._id;
                    tasks[i].notes.push({
                        comment: 'Set Trade Manager ' + $scope.new_manager.name + 
                            ' and Foreman ' + $scope.new_foreman.name + ' in Jobsite Information',
                        date: new Date(),
                        username: $scope.user.username
                    });
                    tasks[i].$update();
                }
            });
        }

        this.selectedItem.$update();
    };

    $scope.acceptManagementCombinationEdits = function() {
        console.log(this);
        var trade = $filter('filter')(this.selectedItem.trades, {'name': $scope.current_selected_trade}, true);
        if(trade.length !== 1) {
            alert('Problem getting the trade ' + $scope.current_selected_trade + ' from the project info');
            return;
        }

        if(!this.selected_manager || !this.selected_manager.name) {
            toaster.pop('error', 'Manager Not Selected');
            return;
        }

        if(!this.selected_foreman || !this.selected_foreman.name) {
            toaster.pop('error', 'Foreman Not Selected');
            return;
        }

        if(!this.selected_tasks || this.selected_tasks.length === 0) {
            toaster.pop('error', 'Task Not Selected');
            return;
        }

        $scope.current_selected_combo.foreman = {
            email: this.selected_foreman.email,
            name: this.selected_foreman.name,
            phone: this.selected_foreman.phone,
            username: this.selected_foreman.username
        }

        var tasks_to_update = [];
        $scope.current_selected_combo.tasks = [];
        _.each(this.selected_tasks, function(task) {
            tasks_to_update.push(task.trade + task.task);
            $scope.current_selected_combo.tasks.push({
                'code': task.trade + task.task
            });
        });

        var tasks_to_reset = [];
        //add original tasks to the list if needed
        _.each($scope.original_tasks, function(task) {
            if(tasks_to_update.indexOf(task) === -1) {
                tasks_to_update.push(task);
                tasks_to_reset.push(task);
            }
        });

        $scope.current_selected_combo.manager = {
            email: this.selected_manager.email,
            name: this.selected_manager.name,
            phone: this.selected_manager.phone,
            username: this.selected_manager.username
        }

        //Find the scheduled tasks and update those as well. managers only
        ProjectTasks.query({'project_id': $scope.selectedItem._id,
                'complete': false,
                'trade': $scope.user.trade[0]}, function(tasks) {

            console.log(tasks);
            //remove the tasks designated for other management combos
            _.remove(tasks, function(n) {
                return tasks_to_update.indexOf(n.task_code) === -1;
            });

            var manager = $filter('filter')($scope.tm_users, {
                'username': $scope.current_selected_combo.manager.username }, true)[0];

            for(var i=0; i<tasks.length; i++) {
                if(tasks_to_reset.indexOf(tasks[i].task_code) !== -1) {
                    tasks[i].foreman = trade[0].foreman;
                    tasks[i].trade_manager_id = trade[0].manager._id;
                    tasks[i].notes.push({
                        comment: 'Set Trade Manager ' + trade[0].manager.name + 
                            ' and Foreman ' + trade[0].foreman.name + ' in Jobsite Information',
                        date: new Date(),
                        username: $scope.user.username
                    });
                } else {
                    tasks[i].foreman = $scope.current_selected_combo.foreman;
                    tasks[i].trade_manager_id = manager._id;
                    tasks[i].notes.push({
                        comment: 'Set Trade Manager ' + manager.name + 
                            ' and Foreman ' + $scope.current_selected_combo.foreman.name + ' in Jobsite Information',
                        date: new Date(),
                        username: $scope.user.username
                    });
                }
                tasks[i].$update();
            }
        });

        this.selected_manager = this.selected_foreman = {};

        this.selectedItem.$update();
    };

    $scope.editManagementCombination = function(trade, combo) {
        $scope.available_managers = [];
        $scope.available_tasks = [];
        $scope.can_modify_trade = true;

        if(trade.name !== $scope.user.trade[0]) {
            toaster.pop('warning', 'Trade', 'You cannot modify this entry');
            $scope.can_modify_trade = false;
            return;
        }

        $scope.available_tasks = $filter('filter')($scope.tasks, {
            'trade': tradeCodeService.getCode(trade.name)}, true);

        var tasks_to_check = [];
        _.each($scope.available_tasks, function(task) {
            tasks_to_check.push(task.trade + task.task);
        });

        $scope.selected_manager = {};
        $scope.selected_foreman = {};

        _.each(trade.management_combinations, function(manCombo) {
            if(manCombo._id !== combo._id) {
                //cycle through the management combinations
                //to remove tasks from the task list that
                //are already in use.
                _.each(manCombo.tasks, function(task) {
                    if(tasks_to_check.indexOf(task.code) !== -1) {
                        var task = task.code.substring(2);
                        _.remove($scope.available_tasks, function(n) {
                            return n.task == task;
                        });
                    }
                });
            } else {
                //this edit combo is ours so lets set what we have
                //set the foreman and manager
                if(combo.foreman) {
                    $scope.selected_foreman = $filter('filter')($scope.foreman_users, {
                        'username': combo.foreman.username }, true)[0];
                }

                if(combo.manager) {
                    $scope.selected_manager = $filter('filter')($scope.tm_users, {
                        'username': combo.manager.username }, true)[0];
                }

                //set the selected tasks
                _.each(manCombo.tasks, function(task) {
                    if(tasks_to_check.indexOf(task.code) !== -1) {
                        var task = task.code.substring(2);
                        _.each($scope.available_tasks, function(avail) {
                            if(avail.task === task) {
                                $scope.original_tasks.push(avail.trade + avail.task);
                                avail.selected = true;
                            }
                        });
                    }
                });
            }
        });

        $scope.current_selected_trade = trade.name;
        $scope.current_selected_combo = combo;

        $scope.available_managers = $scope.tm_users;
        $scope.available_foremen = $scope.foreman_users;
    };

    $scope.addManagementCombination = function(trade) {
        var idx = this.selectedItem.trades.indexOf(trade);
        var tradeUpdate = this.selectedItem.trades[idx];

        if(!tradeUpdate.management_combinations) tradeUpdate.management_combinations = [];

        tradeUpdate.management_combinations.push({
            'manager': {},
            'foreman': {},
            'tasks': []
        });

        this.selectedItem.$update();
    };

    $scope.removeManagementCombination = function(trade, idx) {
        var idx = this.selectedItem.trades.indexOf(trade);
        var tradeUpdate = this.selectedItem.trades[idx];

        tradeUpdate.management_combinations.splice(idx, 1);

        this.selectedItem.$update();
    };

    $scope.getPlanHoursAllowed = function(task_code, trade, plan_code) {
        var code = trade + task_code;
        var tmp_task = $filter('filter')($scope.bid_tasks, {
                'plan_code': plan_code, 
                'task_code': code }, true);

        return (tmp_task.length === 1) ? tmp_task[0].totals.hours_allowed : 0;
    };

    $scope.onPlanSelect = function(item) {
        $scope.current_plan = item;

        $scope.tasks = [];

        $scope.selectedItem.plan[0].task_list.forEach(function(task) {
            //This will get specific plan code based tasks. 
            //It will not get information for Standard
            var tmp_task = $filter('filter')($scope.bid_tasks, {
                'plan_code': $scope.current_plan.item, 
                'task_id': task.order}, true);

            var days = {};

            if(tmp_task.length > 0 && tmp_task[0].days) {
                days = tmp_task[0].days;
            }

            if(tmp_task.length === 1) {
                $scope.tasks.push({
                    name: task.name,
                    trade: task.trade,
                    task: task.task,
                    order: task.order,
                    days: days,
                    days_offset: task.days_offset,
                    hours_allowed: tmp_task[0].totals.hours_allowed,
                    bid_hours: tmp_task[0].totals.bid_hours,
                    plan_code: tmp_task[0].plan_code,
                    task_id: tmp_task[0].task_id
                });
            } else {
                //var plan = $filter('filter')($scope.selectedItem.plan, {'item': $scope.current_plan.item}, true)[0];
                var update = $filter('filter')($scope.selectedItem.plan[0].task_list, {'order': task.order}, true)[0];
                
                //customer wants table highlighting in the Standard plan view
                //for tasks that have hours_allowed.
                var tmp_task = $filter('filter')($scope.bid_tasks, {'task_id': task.order}, true);
                var hours = 0;
                if(tmp_task.length > 0) {
                    hours = tmp_task[0].totals.hours_allowed;
                }

                $scope.tasks.push({
                    name: update.name,
                    trade: update.trade,
                    task: update.task,
                    days: update.days,
                    days_offset: task.days_offset,
                    hours_allowed: hours,
                    order: update.order
                });
            }
        });
    };

    $scope.setEdit =  function(p) {
        p.group_option = p.phase.charAt(3);
        p.phase = p.phase.substring(0,3);
        p.start_date = new Date(p.start_date);
        $scope.editId = p._id;
        $scope.editLot = p.number;
        $scope.editPhase = p.phase;
        $scope.editPlan = p.plan;
        $scope.editStartDate = p.start_date;
        $scope.editOpened = false;
    };

    $scope.cancelEdit = function(lot) {
        $scope.editId = -1;
        lot.number = $scope.editLot;
        lot.phase = $scope.editPhase;
        lot.plan = $scope.editPlan;
        lot.start_date = $scope.editStartDate;
        $scope.editOpened = false;
    };

    $scope.saveLot = function(lot) {
        lot.phase = lot.phase + lot.group_option;
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();
            toaster.pop('success','Lot Updated');
        }, function(error) {
            toaster.pop('error','Save Lot Error', error);
        });

        $scope.editId = -1;
        $scope.editOpened = false;
    };

    $scope.editItem = function (item) {
        item.editing = true;
    };

    $scope.doneEditing = function (item) {
        if(!item.editing) return;

        var save = $filter('filter')($scope.selectedItem.plan[0].task_list, {'order': item.order}, true)[0];

        if(!save) {
            alert('Could not find editable task in list.  Contact Admin.');
            return;
        } 

        //days get updated to the main task list
        save.days = Number(item.days);

        //days get updated to the bid_tasks this change is associated with
        var tmp = $filter('filter')($scope.bid_tasks, {'task_id': item.order}, true);
        tmp.forEach(function(me) {
            me.days = save.days;
            me.$update();
        });
        
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();
            toaster.pop('success','Lot Updated');
        }, function(error) {
            toaster.pop('error','Save Lot Error', error);
        });

        item.editing = false;
    };

    $scope.editItem2 = function (item) {
        item.editing2 = true;
    };

    $scope.doneEditing2 = function (item) {
        if(!item.editing2) return;

        var save = $filter('filter')($scope.selectedItem.plan[0].task_list, {'order': item.order}, true)[0];

        if(!save) {
            alert('Could not find editable task in list.  Contact Admin.');
            return;
        } 

        //days get updated to the main task list
        save.days_offset = Number(item.days_offset);

        //days get updated to the bid_tasks this change is associated with
        var tmp = $filter('filter')($scope.bid_tasks, {'task_id': item.order}, true);
        tmp.forEach(function(me) {
            me.days = save.days_offset;
            me.$update();
        });
        
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();
            toaster.pop('success','Lot Updated');
        }, function(error) {
            toaster.pop('error','Save Lot Error', error);
        });

        item.editing2 = false;
    };

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.opened = true;
    };

    $scope.editOpen = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        //$timeout(function() {
            this.editOpened = true;
        //}, 50);
    };

    $scope.datePickerSelected = function() {
        console.log('datepicker selected');
    };

    $scope.addLot = function() {
        console.log(this);
        var phase = '';
        var lot = this.selectedItem.lot_number;
        
        if($scope.selectedItem.group_option) {
            phase = this.selectedItem.phase_number + $scope.selectedItem.group_option;
        } else {
            phase = this.selectedItem.phase_number;
        }

        var inlist = $filter('filter')(this.selectedItem.lots, {
            'number': this.selectedItem.lot_number,
            'phase': phase }, true);

        if(inlist.length > 0) {
            toaster.pop('error', 'Lot Scheduling',
                'Cannot have the same lot/phase combination.');
            return;
        }

        if(this.selectedItem.lot_number && 
            this.selectedItem.plan_choice && this.selectedItem.start_date) {
            if(!this.selectedItem.group_option) this.selectedItem.group_option = '';
            this.selectedItem.lots.push({
                number: this.selectedItem.lot_number,
                phase: phase,
                plan: this.selectedItem.plan_choice.item,
                reverse: this.selectedItem.reverse,
                color_scheme: this.color_scheme?this.color_scheme.name:'',
                start_date: this.selectedItem.start_date,
                revision: this.selectedRevision.number
            });

            if(!this.selectedItem.lots[this.selectedItem.lots.length-1].revisions) {
                this.selectedItem.lots[this.selectedItem.lots.length-1].revisions = [];
            }

            this.selectedItem.lots[this.selectedItem.lots.length-1].revisions.push({
                trade: $scope.user.trade[0],
                revision: this.selectedRevision.number
            });

            //$scope.ordered_lots = $filter('orderBy')($scope.selectedItem.lots, ['phase', 'number']);
            $scope.ordered_lots = $scope.selectedItem.lots;
            this.selectedItem.mainAccountId = $scope.main_account['_id'] || $scope.main_account;
            this.selectedItem.$update(function(success) {
                $scope.selectedItem = success;
                $scope.normalizeLotRevisions();
                lotService.add(
                    lot, 
                    phase,
                    $scope.selectedItem.trade_code,
                    $scope.selectedItem.company_code,
                    $scope.selectedItem._id);

                toaster.pop('success', 'Lot Added');
            }, function(error) {
                toaster.pop('error', 'Lot Add Error', error);
            });

            this.selectedItem.lot_number =
            this.selectedItem.phase_number = 
            this.selectedItem.group_option =
            this.selectedItem.plan_choice = 
            this.color_scheme = 
            this.selectedItem.start_date = '';
            this.selectedRevision = $scope.revisions[$scope.revisions.length-1];
        } else {
            alert('please enter all fields');
        }
    };

    $scope.removeLot = function(lot) {
        // $scope.dontResetLot = true;
        // $scope.resetLot(lot);
        if(lot.scheduled) {
            toaster.pop('error', 'Lot Scheduled Error', 'Please RESET lot prior to removing');
            return;
        }
        
        var index = $scope.selectedItem.lots.indexOf(lot);
        $scope.selectedItem.lots.splice(index, 1);
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();
            lotService.remove(
                lot.number, 
                lot.phase,
                $scope.selectedItem.trade_code,
                $scope.selectedItem.company_code,
                $scope.selectedItem._id);
            toaster.pop('success', 'Lot Removed');
        }, function(error) {
            toaster.pop('error', 'Lot Remove Error', error);
        });
    };

    $scope.updateProject = function() {
        this.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.bid.$update();
            $scope.normalizeLotRevisions();
            toaster.pop('success','Project Updated');
        }, function(error) {
            toaster.pop('error','Save Lot Error', error);
        });
    };

    $scope.registerApi = function(api) {
        $scope.api = api;

        api.core.on.ready($scope, function () {
            api.tasks.on.change($scope, onTaskChange);
        });
    }

    // Events
    var onTaskChange = function (selected) {
        // console.log('new diff time: ' + moment.duration(selected.model.to.diff(selected.model.from)).asDays());
        // console.log('new from time: ' + selected.model.from.get().format('DDD'));

        var task = $filter('filter')($scope.selectedItem.plan[0].task_list, {'order': selected.model.data.order}, true)[0];

        if(!task) {
            alert('Problem getting the task for changing.  Contact Admin.');

            return;
        }

        task.days = Number(moment.duration(selected.model.to.diff(selected.model.from)).asDays());
        //console.log(selected.model.from);
        task.days_offset = Number(selected.model.from.format('DDD')) - 1;

        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();

            var tasks = $filter('filter')($scope.bid_tasks, {'task_id': selected.model.data.order}, true);
            tasks.forEach(function(task) {
                task.days = Number(moment.duration(selected.model.to.diff(selected.model.from)).asDays());
                task.days_offset = Number(selected.model.from.format('DDD')) - 1;
                task.$update();
            });
            toaster.pop('success','Project Updated');
        }, function(error) {
            toaster.pop('error','Save Lot Error', error);
        });
    };

    $scope.timeFrames = {
        day: {
            start: moment('00:00', 'HH:mm'),
            end: moment('23:59', 'HH:mm'),
            working: true, // This is a working period
            default: true // It will be used for each day
        },
        noon: {
            start: moment('12:00', 'HH:mm'),
            end: moment('13:30', 'HH:mm'),
            magnet: false, // This will disable magnet snapping
            working: false, // This is a resting period
            default: true // It will be used for each day
        },
        closed: {
            magnet: false, // This will disable magnet snapping
            working: false // We don't work when it's closed
        }
    };

    $scope.dateFrames = {
        halloween:{
            date: moment('2015-01-31', 'YYYY-MM-DD'), // A specific date
            targets: ['day'] // Use timeFrame named day for halloween. We won't close for noon.
        },
        holidays: {
            start: moment('2015-02-15', 'YYYY-MM-DD'), // A date range
            end: moment('2014-02-30', 'YYYY-MM-DD'),
            targets: ['closed'] // use timeFrame named closed for this date range.
        }, 
        weekend: {
            evaluator: function(date) { // A custom function evaluated for each day in the gantt
            return date.isoWeekday() === 6 || date.isoWeekday() === 7;
        },
        targets: ['closed'] // Use timeFrame named closed for saturday and sunday.
        }
    };

    $scope.getColumnWidth = function(widthEnabled, scale, zoom) {
        if (!widthEnabled && $scope.canAutoWidth(scale)) {
            return undefined;
        }

        if (scale.match(/.*?week.*?/)) {
            return 150 * zoom;
        }

        if (scale.match(/.*?month.*?/)) {
            return 300 * zoom;
        }

        if (scale.match(/.*?quarter.*?/)) {
            return 500 * zoom;
        }

        if (scale.match(/.*?year.*?/)) {
            return 800 * zoom;
        }

        return 40 * zoom;
    };

    $scope.checkLots = function() {
        $scope.selectedItem.lots.forEach(function(lot) {
            console.log('lot ' + lot.number + ' scheduled value: ' + lot.scheduled);
        });
    };

    $scope.resetLot = function(lot) {
        if($scope.is_admin) {
            ProjectTasks.query({'type': 'DeleteByIdLotPhase', 
                'project_id': $scope.selectedItem._id, 
                'lot': lot.number, 'phase': lot.phase}, function(tasks) {

                console.log(tasks.length);
                if(tasks.length === 0) {
                    lot.scheduled = false;
                    $scope.selectedItem.$update(function(success) {
                        $scope.selectedItem = success;
                        $scope.normalizeLotRevisions();
                        if($scope.dontResetLot) {
                            $scope.dontResetLot = false;
                        } else {
                            lotService.reset(
                                lot.number, 
                                lot.phase,
                                $scope.selectedItem.trade_code,
                                $scope.selectedItem.company_code,
                                $scope.selectedItem._id);
                        }

                        toaster.pop('success', 'Lot Reset', 
                            'Database has been updated');
                    }, function(error) {
                        toaster.pop('error', 'Lot Reset Error', error);
                    });
                } else {
                    toaster.pop('error', 'Project Tasks Not Removed', 
                        'Database was not able to remove all project tasks');
                }
            });
        }
    };

    $scope.padDigits = function(number, digits) {
        return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
    };

    $scope.scheduleLot = function(lot) {
        if(!$scope.selectedItem.contact.timezone) {
            alert('You must specify a timezone in the Edit Projects tab  in the format -0600');
            return;
        }

        console.log('scheduling lot');
        if(lot.revision === $scope.totalRevisionLength) {
            lotScheduleService.schedule(lot, $scope.selectedItem, 
                $scope.bid_tasks, $scope.user, $scope.tm_users).then(function(results) {

                ProjectTasks.bulkAdd(results, function(results) {
                    toaster.pop('success', 
                        'Lot Scheduled', 
                        'Lot ' + lot.number + ' saved to database');

                    lot.scheduled = true;
                    $scope.selectedItem.$update(function(success) {
                        $scope.selectedItem = success;
                        $scope.normalizeLotRevisions();
                        lotService.schedule(
                            lot,
                            $scope.selectedItem.trade_code,
                            $scope.selectedItem.company_code,
                            $scope.selectedItem._id);

                        //toaster.pop('success', 'Lot Scheduled');
                    }, function(error) {
                        toaster.pop('error', 'Lot Schedule Error', error);
                    });
                });
            });
        } else {
            ProjectBids.query({
                'project_id':$scope.selectedItem._id, 
                'trade': MeanUser.user.trade[0],
                'complete': false,
                'revision': lot.revision}, function(bid_tasks) {
                $scope.bid_tasks = bid_tasks;
                lotScheduleService.schedule(lot, $scope.selectedItem, 
                    bid_tasks, $scope.user, $scope.tm_users).then(function(results) {

                    ProjectTasks.bulkAdd(results, function(results) {
                        toaster.pop('success', 
                            'Lot Scheduled', 
                            'Lot ' + lot.number + ' saved to database');

                        lot.scheduled = true;
                        $scope.selectedItem.$update(function(success) {
                            $scope.selectedItem = success;
                            $scope.normalizeLotRevisions();
                            lotService.schedule(
                                lot,
                                $scope.selectedItem.trade_code,
                                $scope.selectedItem.company_code,
                                $scope.selectedItem._id);

                            //toaster.pop('success', 'Lot Scheduled');
                        }, function(error) {
                            toaster.pop('error', 'Lot Schedule Error', error);
                        });
                    });
                });
            });
        }
    };

    $scope.rescheduleLot = function(lot) {
        if(!$scope.selectedItem.contact.timezone) {
            alert('You must specify a timezone in the Edit Projects tab  in the format -0600');
            return;
        }

        if(lot.revision === $scope.totalRevisionLength) {
            lotScheduleService.schedule(lot, $scope.selectedItem, 
                $scope.bid_tasks, $scope.user, $scope.tm_users).then(function(results) {
                var lot_start_date = lot.start_date;
                console.log('im here'); //$scope.project_tasks
                ProjectTasks.query({
                    'project_id': $scope.selectedItem._id,
                    'lot': lot.number, 'phase': lot.phase }, function(project_tasks) {

                    if(results.length !== project_tasks.length) {
                        toaster.pop('error', 'Project Task Error', 
                            'Cannot reschedule lot.  contact admin');
                        return;
                    }

                    _.each(results, function(task) {
                        var inlist = $filter('filter')(project_tasks, {
                            'trade': task.trade, 'task_code': task.task_code,
                            'task_name': task.task_name }, true);

                        if(inlist.length !== 1) {
                            toaster.pop('error', 'Task Reschedule Error',
                                'Could not complete action.  Contact admin.');
                            return;
                        }

                        if(inlist[0].days !== task.days) {
                            console.log('days do not match up.  Setting from rescheduled...');
                            inlist[0].days = task.days;
                        }

                        inlist[0].start_date = new Date(task.start_date);
                        inlist[0].end_date = new Date(task.end_date);

                        inlist[0].days_offset = 
                            daysDifferenceService.getDaysFromStart(
                                lot_start_date, inlist[0].start_date);

                        inlist[0].$update();
                    });

                    toaster.pop('success', 'Lot Rescheduled');
                    lotService.reschedule(
                        lot,
                        $scope.selectedItem.trade_code,
                        $scope.selectedItem.company_code,
                        $scope.selectedItem._id);
                });
            });
        } else {
            ProjectBids.query({
                'project_id':$scope.selectedItem._id, 
                'trade': MeanUser.user.trade[0],
                'complete': false,
                'plan_code': lot.plan,
                'revision': lot.revision}, function(bid_tasks) {
                    $scope.bid_tasks = bid_tasks;
                    lotScheduleService.schedule(lot, $scope.selectedItem, 
                    bid_tasks, $scope.user, $scope.tm_users).then(function(results) {

                    console.log('im here'); //$scope.project_tasks
                    ProjectTasks.query({
                        'project_id': $scope.selectedItem._id,
                        'lot': lot.number, 'phase': lot.phase }, function(project_tasks) {

                        if(results.length !== project_tasks.length) {
                            toaster.pop('error', 'Project Task Error', 
                                'Cannot reschedule lot.  contact admin');
                            return;
                        }

                        _.each(results, function(task) {
                            var inlist = $filter('filter')(project_tasks, {
                                'trade': task.trade, 'task_code': task.task_code,
                                'task_name': task.task_name }, true);

                            if(inlist.length !== 1) {
                                toaster.pop('error', 'Task Reschedule Error',
                                    'Could not complete action.  Contact admin.');
                                return;
                            }

                            if(inlist[0].days !== task.days) {
                                console.log('days do not match up.  Setting from rescheduled...');
                                inlist[0].days = task.days;
                            }

                            inlist[0].start_date = new Date(task.start_date);
                            inlist[0].end_date = new Date(task.end_date);

                            inlist[0].days_offset = 
                                daysDifferenceService.getDaysFromStart(
                                    lot.start_date, inlist[0].start_date);
                                
                            inlist[0].$update();
                        });

                        toaster.pop('success', 'Lot Rescheduled');
                        lotService.reschedule(
                            lot,
                            $scope.selectedItem.trade_code,
                            $scope.selectedItem.company_code,
                            $scope.selectedItem._id);
                    });
                });
            });
        }
    };

    $scope.scheduleAllLots = function() {
        $scope.selectedItem.lots.forEach(function(lot) {
            if(!lot.scheduled) {
                $scope.scheduleLot(lot);
            }
        });
    };

    // $scope.copyNotes = function() {
    //     console.log('copy function... ' + $scope.selectedItem);
    //     Bids.query({'bid_status': 'project'}, function(bid) {
    //         console.log('bids returned... ' + bid);
    //     });
    // };
    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };
 
    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };

    $scope.fileSelected = function() {
        var lines, lineNumber, data, length;
        
        lines = this.$parent.fileContent.split('\n');
        lineNumber = 0;

        var check = angular.copy($scope.selectedItem.plan[0].task_list);
        $scope.good = true;

        var error_q = [];
        var count = 0;

        $scope.selectedItem.plan[0].task_list = [];
        for (var i = 1; i < lines.length; i++) {
            var l = lines[i];

            lineNumber++;
            data = l.split(',');

            if(data[0] === '') continue;

            var order = Number(data[0].replace(/[^0-9\.]+/g,""));
            var trade = data[1].toString();
            var task = data[2].toString();
            var name = data[3];
            var days_offset = Number(data[4].replace(/[^0-9\.]+/g,""));
            var days = Number(data[5].replace(/[^0-9\.]+/g,""));

            var inlist = $filter('filter')(check, {'trade': trade, 'task': task}, true);

            if(inlist.length !== 1) {
                $scope.good = false;
                if(inlist.length === 0) {
                    error_q.push({
                        msg: 'Error: Trade ' + trade + ' and Task ' + task + ' not found.  '
                    });
                } else {
                    error_q.push({
                        msg: 'Error: Trade ' + trade + ' and Task ' + task + ' found too many.  '
                    });
                }
            }

            inlist = $filter('filter')(check, {'name': name}, true);

            if(inlist.length !== 1) {
                $scope.good = false;
                if(inlist.length === 0) {
                    error_q.push({
                        msg: 'Error: Name ' + name + ' not found.  '
                    });
                } else {
                    error_q.push({
                        msg: 'Error: Name ' + name + ' found too many.  '
                    });
                }
            }

            count++;

            $scope.selectedItem.plan[0].task_list.push({
                name: name,
                trade: trade,
                task: task,
                days: days,
                days_offset: days_offset,
                hours_allowed: 0,
                order: order
            });
        }

        console.log('Lines: ' + count + ', Tasks: ' + $scope.selectedItem.plan[0].task_list.length);
        if(count !== $scope.selectedItem.plan[0].task_list.length) {
            toaster.pop('error', 'CSV File', 'The number of tasks in the file do not match');
            return;
        }

        if($scope.good) {
            $scope.selectedItem.$update(function(result) {
                $scope.selectedItem = result;
                $scope.normalizeLotRevisions();
                toaster.pop('success', 'Database Updated', 'Updated the schedule');
                $scope.tasks = result.plan[0].task_list;
            }, function(error) {
                toaster.pop('error', 'Database Update', 'The system did not save the schedule');
                error_q.forEach(function(err) {
                    toaster.pop('error', 'Database Update', error);
                });
            });

            delete this.$parent.fileContent;
        } else {
            toaster.pop('error', 'CSV File', 'Problem with the csv file');
            error_q.forEach(function(err) {
                toaster.pop('error', 'Database Update', err.msg);
            });
        }
    };

    $scope.ConvertToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'Order,Trade Code,Task Code,Name,Days From Start,No of Days\r\n';

        for (var i = 0; i < array.length; i++) {
            str += array[i].order + ',' + array[i].trade + ',' 
                    + array[i].task + ',' + array[i].name + ',' 
                    + array[i].days_offset + ',' + array[i].days + '\r\n';
        }

        return str;
    };

    $scope.exportFile = function() {
        var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertToCSV($scope.tasks));
        var link = document.createElement('a');
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'task-schedule.csv') // Pretty much only works in chrome
        link.click();
    };

    $scope.getMaterialColorCode = function(material, lot) {
        if(!lot) return;

        //gets the default color code for this lot
        var option = $filter('filter')(material.color_scheme, {
            'category': lot.color_scheme }, true);
        if(option > 1) {
            toaster.pop('error', 'projectAdmin line 1130', 'issue with getting color scheme code');
            return;
        }

        //now we need to see if the user has overrides
        //first find the bid associated with this material
        var total_bid_tasks = [];
        for(var i=0; i<$scope.bid_tasks.length; i++) {
            var mat = $filter('filter')($scope.bid_tasks[i].materials, {
                'name': material.name,
                'note': material.note }, true);
            if(mat.length) {
                total_bid_tasks.push($scope.bid_tasks[i]);
            }
        }

        //now see if we have a color code saved
        for(var i=0; i<total_bid_tasks.length; i++) {
            var tasks = $filter('filter')($scope.project_tasks, {
                //'project_bid_id': total_bid_tasks[i]._id,
                'lot': lot.number, 
                'phase': lot.phase,
                'task_code': total_bid_tasks[i].task_code }, true); 

            if(tasks.length === 1) {
                var code_info = $filter('filter')(tasks[0].color_codes, {
                    'material_name': material.name,
                    'material_note': material.note }, true);
                
                if(code_info.length === 1)
                    return code_info[0].code;
            } 
        }
            
        if(option.length === 1) { 
            return option[0].option;
        } else {
            return '';
        }
    };

    $scope.updateColorScheme = function() {
        //$scope.updateLotMaterialColorScheme = function(material, lot, current)
        $scope.changeProject();
    };

    $scope.updateOptionColorScheme = function(item) {
        var orig_option = {};
        _.each($scope.trade_options.options, function(opt) {
            _.each(opt.subtasks, function(sub) {
                var inlist = $filter('filter')(sub.materials, {'_id': item._id}, true);
                if(inlist.length !== 0) {
                    orig_option = opt;
                }
            });
        });

        item.color_scheme = angular.copy(item.categories);

        _.each(orig_option.subtasks, function(subtask) {
            var materials = $filter('filter')(subtask.materials, {
                'name': item.name, 'note': item.note, 'supplier': item.supplier, 'task_code': item.task_code}, true);
            _.each(materials, function(mat) {
                mat.color_scheme = angular.copy(item.categories);
            });
        });

        $scope.trade_options.$update();
    };

    $scope.updateMaterialColorScheme = function(item) {
        item.color_scheme = item.categories;

        var materials = $filter('filter')($scope.materials, {
            'name': item.name, 'note': item.note, 'supplier': item.supplier}, true);

        if(!angular.isUndefined(item.material_id)) {
            console.log('Material ' + item.name + 
                ' is a regular bid_task material.  Adding color scheme info');
            var items_to_update = [];

            //add the color scheme information to each material
            _.each(materials, function(material) {
                material.color_scheme = angular.copy(item.categories);

                _.each($scope.bid_tasks, function(bid_task) {
                    var update = $filter('filter')(bid_task.materials, {'_id': material._id}, true);
                    if(update.length > 0) {
                        _.each(update, function(up) {
                            up.color_scheme = angular.copy(item.categories);
                        });

                        var inlist = $filter('filter')(items_to_update, {'_id': bid_task._id}, true);
                        if(inlist.length === 0) {
                            items_to_update.push(bid_task);
                        }
                    }
                });
            });

            _.each(items_to_update, function(bid_task) {
                bid_task.$update(function(success) {

                }, function(error) {
                    toaster.pop('error', 'Project Bid Update Error', error);
                });
            });
        } else {
            console.log('Material ' + item.name + 
                ' is an option material.  Adding color scheme info');

            _.each($scope.trade_options.options, function(option) {
                _.each(option.subtasks, function(subtask) {
                    var items = $filter('filter')(subtask.materials, {
                        'name': item.name, 'note': item.note, 'supplier': item.supplier}, true);

                    _.each(items, function(material) {
                        material.color_scheme = angular.copy(item.categories);
                    });
                });
            });

            $scope.trade_options.$update(function(success) {
                $scope.trade_options = success;
                toaster.pop('success', 'Material Updated');
            }, function(error) {
                toaster.pop('error', 'Database Error', error);
            });
        }
    };

    $scope.updateMaterialColorScheme2 = function(item, name, option) {
        var materials = [];

        _.each($scope.bid_tasks, function(task) {
            var inlist = $filter('filter')(task.materials, {
                'name': item.name, 'note': item.note, 'supplier': item.supplier}, true);
            _.each(inlist, function(mat) {
                materials.push(mat);
            });
        });


        //add the color scheme information to each material
        _.each(materials, function(material) {
            var inlist = $filter('filter')(material.color_scheme, {
                'category': name }, true);
            if(inlist.length === 0) {
                //add new option to list
                material.color_scheme.push({
                    'category': name,
                    'option': option
                });
            } else if(inlist.length === 1) {
                inlist[0].option = option;
            } else {
                toaster.pop('error', 'Finding Color Scheme', 
                    'Too many entries for this color scheme code.  Contact admin.');
                return;
            }
        });
    };

    $scope.clearColorSchemeDate = function() {
        _.each($scope.bid_tasks, function(task) {
            _.each(task.materials, function(mat) {
                mat.color_scheme = [];
            });
            task.$update();
        });

        $scope.buildConsolidatedMaterials();
        //$scope.buildOptionMaterials();
        $scope.updateMaterialData(true);
    };

    $scope.updateLotMaterialColorScheme = function(material, lot, current) {
        var total_bid_tasks = [];

        //materials in the list are consolidated on name and note.
        //find all the bids that have the material name/note combo
        for(var i=0; i<$scope.bid_tasks.length; i++) {
            var mat = $filter('filter')($scope.bid_tasks[i].materials, {
                'name': material.name,
                'note': material.note }, true);
            if(mat.length) {
                total_bid_tasks.push($scope.bid_tasks[i]);
            }
        }

        var found = false;
        var tasks_updated = [];
        //find project tasks that are associated with the bids we found
        for(var i=0; i<total_bid_tasks.length; i++) {
            var task = $filter('filter')($scope.project_tasks, {
                //'project_bid_id': total_bid_tasks[i]._id,
                'phase': lot.phase, 'lot': lot.number, 
                'plan_code': lot.plan, 'task_code': total_bid_tasks[i].task_code }, true);

            //do we have a matching projectTask
            if(task.length === 1 && tasks_updated.indexOf(task[0]._id) === -1) {
                found = true;
                tasks_updated.push(task[0]._id);
                var update = $filter('filter')(task[0].color_codes, {
                    'material_name': material.name,
                    'material_note': material.note }, true);

                if(update.length === 1) {
                    update[0].code = current;
                } else if(update.length === 0) {
                    task[0].color_codes.push({
                        'material_name': material.name,
                        'material_note': material.note,
                        'code': current
                    });
                } else {
                    //got too many material name/note combos
                    //might be best to dialog the user to clean
                    //up or something...for now warn and return
                    toaster.pop('error', 'Cannot Determine Material',
                        material.name + ' has too many entries.');
                    return;
                }
                task[0].$update(function(success) {
                    //update the projectMaterials here
                    updateMaterialColorService.update(
                        $scope.selectedItem, success, lot, material);
                }, function(error) {
                    toaster.pop('error', 'Project Task Update Error', error);
                });
            }
        }

        if(!found) {
            var reset = $filter('filter')(material.color_scheme, {
                'category': lot.color_scheme }, true);

            if(reset.length === 1) {
                lot.current = reset[0].option;
            }
            toaster.pop('warning', 'Project Task Update', 
                'Could not find a task.  Check that this lot has been scheduled');
        }
    };

    $scope.addColorScheme = function(items) {
        items = items.split(',');

        for(var i=0; i<items.length; i++) {
            var inlist = $filter('filter')($scope.cs_categories, {
                'name': items[i] }, true);

            if(inlist.length === 0) {
                $scope.cs_categories.push({
                    name: items[i].replace(/[\s]/g, '')
                });
            }
        }

        if(!$scope.selectedItem.trades[0].color_scheme_codes) {
            $scope.selectedItem.trades[0].color_scheme_codes = [];
        }
        
        $scope.selectedItem.trades[0].color_scheme_codes = $scope.cs_categories;
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();
        }, function(error) {
            toaster.pop('error', 'Database Update Error', 'Could not save the project.');
            return;
        });
        // function(success) {
        //     $scope.selectedItem = success;
        // }, function(error) {
        //     toaster.pop('error', 'Database Update Error', 'Could not save the project.');
        //     return;
        // });
        this.input_scheme = '';
    };

    $scope.removeColorScheme = function(item) {
        var inlist = $filter('filter')($scope.selectedItem.lots, {
            'color_scheme': item.name }, true);

        if(inlist.length > 0) {
            toaster.pop('error', 'Lot Error', 
                'Please Remove Lot ' + item.name + ' Before Deleting');
            return;
        }

        _.each($scope.bid_tasks, function(task) {
            _.each(task.materials, function(mat) {
                _.remove(mat.color_scheme, function(color) {
                    // if(!color) {
                    //     return false;
                    // } 
                    return color.category === item.name;
                });
            });
            task.$update();
            // function(success) {
            //     var inlist = $filter('filter')($scope.bid_tasks, {'_id': success._id}, true);
            //     if(inlist.length !== 1) {
            //         toaster.pop('error', 'Task Update Error', 'Contact admin');
            //         return;
            //     }

            //     inlist[0] = success;
            // }, function(error) {
            //     toaster.pop('error', 'Task Update Error', 'Contact admin');
            //     return;
            // });
        });

        // _.each($scope.consolidated_materials, function(mat) {
        //     _.remove(mat.color_scheme, function(color) {
        //         return color.category === item.name;
        //     });
        // });
        $scope.buildConsolidatedMaterials();
        //$scope.buildOptionMaterials();
        $scope.updateMaterialData(false);

        var idx = $scope.cs_categories.indexOf(item);
        $scope.cs_categories.splice(idx, 1);

        $scope.selectedItem.trades[0].color_scheme_codes = $scope.cs_categories;
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();
        }, function(error) {
            toaster.pop('error', 'Database Update Error', 'Could not save the project.');
            return;
        });
    };

    $scope.fileColorSelected = function() {
        console.log('in fileColorSelected');
        var lines, lineNumber, data, length;

        $scope.buildConsolidatedMaterials();
        
        lines = this.$parent.fileColorContent.split('\n');
        lineNumber = 0;
        //var holder = [];
        for (var i = lines.length - 1; i > 0; i--) {
            var l = lines[i];

            lineNumber++;
            data = l.split(',');

            if(!data[0]) continue; 

            //clear out all color_scheme data
            $scope.consolidated_materials[i-1].color_scheme = [];

            for(var j=0; j<$scope.cs_categories.length; j++) {
                var insert = {
                    option: data[j+4].replace(/(\r\n|\n|\r)/gm,""),
                    category: $scope.cs_categories[j].name
                }

                var item = [];
                if(data[2] === '') {
                    item = $filter('filter')($scope.consolidated_materials, {
                        'task_code': data[0], 'name': data[1], 'supplier': data[3] }, true);

                    //remove items that have a note
                    _.remove(item, function(mat) {
                        return !angular.isUndefined(mat.note);
                    });
                } else {
                    item = $filter('filter')($scope.consolidated_materials, {
                        'task_code': data[0], 'name': data[1], 'supplier': data[3], 'note': data[2] }, true);
                }

                if(item.length !== 1) {
                    toaster.pop('error', 'Import File Error', 
                        'Cannot find material.');
                    return;
                }

                item[0].color_scheme.splice(j, 0, insert);
            }
        }

        _.each($scope.consolidated_materials, function(mat) {
            _.each($scope.cs_categories, function(color) {
                if(color){
                    var item = $filter('filter')(mat.color_scheme, {'category': color.name}, true)
                    if(item.length !== 1) {
                        console.log('there are issues');
                        return;
                    }
                    $scope.updateMaterialColorScheme2(
                        mat, 
                        color.name, 
                        item[0].option);
                } else {
                    toaster.pop('warning', 'NULL Data Error',  
                        'Could not find color data for ' + mat.name);
                }
            });
        });

        for(var j=0; j<$scope.bid_tasks.length; j++) {
            $scope.bid_tasks[j].$update();
        }

        console.log('Saving trade options after material update');

        $scope.trade_options.$update(function(success) {
            $scope.buildConsolidatedMaterials();
            $scope.updateMaterialData(true);
        }, function(error) {
            toaster.pop('error', 'Trade Option DB Error' + error);
        });

        delete this.$parent.fileColorContent;
    };

    $scope.ConvertColorToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'TASK CODE,PRODUCT,BID NOTE,SUPPLIER';
        for(var i=0; i<$scope.cs_categories.length; i++) {
            str += ',' + $scope.cs_categories[i].name.replace(/[\s]/g, '');
        }
        str += '\r\n';

        var cs_size = $scope.cs_categories.length;

        for(var i=0; i<array.length; i++) {
            var note = (array[i].note)?array[i].note : '';
            str += array[i].task_code + ',' + array[i].name + ',' + note + ',' + array[i].supplier + ',';
            // if(cs_size !== array[i].color_scheme.length) {
            //     toaster.pop('warning', 'Color Scheme DB Error',
            //         'Too many color scheme options.  Trying to repair.');
            // }
            for(var j=0; j<$scope.cs_categories.length; j++) {
                var item = $filter('filter')(array[i].color_scheme, {
                    'category': $scope.cs_categories[j].name }, true);

                if(item.length === 1)
                  str += (item[0].option)?item[0].option.replace(/(\r\n|\n|\r)/gm,""):"";
                else if(item.length > 1) {
                    if(cs_size !== array[i].color_scheme.length) {
                        var is_unique = $filter('unique')(item, 'category');

                        if(is_unique.length === 1) {
                            toaster.pop('success', 'Color Scheme DB Error',
                                'Determined solution.  Fixing...');

                            var first = false;
                            _.each(item, function(ii) {
                                if(!first) {
                                    first = true
                                } else {
                                    var idx = array[i].color_scheme.indexOf(ii);

                                    if(idx !== -1) {
                                        array[i].color_scheme.splice(idx, 1);
                                    } else {
                                        toaster.pop('error', 'Color Scheme DB Error',
                                            'Cannot find ' + ii.category + ' in the array.  '
                                            + 'Contact admin.' );
                                        return;
                                    }
                                }
                            });

                            str += item[0].option.replace(/(\r\n|\n|\r)/gm,"");
                        } else if(is_unique.length === 0) {
                            toaster.pop('error', 'Color Scheme DB Error',
                                'Unique came back with nothing valid.  Contact admin.');
                            return;
                        } else {
                            // toaster.pop('warning', 'Color Scheme DB Error',
                            //     'Unique came back with too many options available.  ' + 
                            //     'Going to see if repairs can still happen...');
                            if(array[i].color_scheme.length === item.length * cs_size) {
                                array[i].color_scheme.splice(cs_size-1, 
                                    array[i].color_scheme.length - cs_size);
                                // toaster.pop('success', 'Color Scheme DB Error',
                                //     'Determined solution.  Fixing...');
                                
                                str += item[0].option.replace(/(\r\n|\n|\r)/gm,"");
                            } else {
                                toaster.pop('error', 'Color Scheme DB Error',
                                    'Could not determine a workable solution.  Contact Admin');
                                return;
                            }
                        }
                    }
                } else {
                  str += '';
                }

                if(j<$scope.cs_categories.length-1)
                    str += ',';
            }
            str += '\r\n';
        }

        return str;
    };

    $scope.ConvertPerLotColorToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = ',PHASE';
        var ordered_lots = angular.copy($scope.ordered_lots);
        ordered_lots = $filter('orderBy')(ordered_lots, ['phase', 'number']);

        for(var i=0; i<ordered_lots.length; i++) {
            str += ',' + ordered_lots[i].phase;
        }
        str += '\r\n';

        str += ',LOT';
        for(var i=0; i<ordered_lots.length; i++) {
            str += ',' + ordered_lots[i].number;
        }
        str += '\r\n';

        str += ',PLAN';
        for(var i=0; i<ordered_lots.length; i++) {
            str += ',' + ordered_lots[i].plan;
        }
        str += '\r\n';

        str += ',COLOR';
        for(var i=0; i<ordered_lots.length; i++) {
            str += ',' + ordered_lots[i].color_scheme.replace(/[\s]/g, '');
        }
        str += '\r\n';

        str += 'PRODUCT,BID NOTE';
        for(var i=0; i<ordered_lots.length; i++) {
            str += ',';
        }
        str += '\r\n';

        for(var i=0; i<array.length; i++) {
            var note = (array[i].note)?array[i].note : '';
            str += array[i].name + ',' + note + ',';
            array[i].lots = $filter('orderBy')(array[i].lots, ['phase', 'number']);
            for(var j=0; j<array[i].lots.length; j++) {
                if(array[i].lots[j].current) {
                    str += array[i].lots[j].current.replace(/(\r\n|\n|\r)/gm,"");
                } 

                if(j<array[i].lots.length-1)
                    str += ',';
            }
            str += '\r\n';
        }

        return str;
    };

    $scope.exportColorFile = function() {
        var filteredList = $filter('filter')($scope.consolidated_materials, {'toggle': false}, true);
        var dataUrl = 'data:text/csv;utf-8,' + 
            encodeURI($scope.ConvertColorToCSV(filteredList));
        var link = document.createElement('a');
      
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'color_scheme_matrix.csv'); // Pretty much only works in chrome
      
        link.click();
    };

    $scope.exportPerLotColorFile = function() {
        var filteredList = $filter('filter')($scope.consolidated_materials, {'toggle': false}, true);
        var dataUrl = 'data:text/csv;utf-8,' + 
            encodeURI($scope.ConvertPerLotColorToCSV(filteredList));
        var link = document.createElement('a');
      
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'color_scheme_per_lot_matrix.csv'); // Pretty much only works in chrome
      
        link.click();
    };

    $scope.getOptionTotal = function(lot) {
        lot.total = 0;
        //var option_sub_totals = 0;
        //var original_sub_totals = 0;

        if(lot.active_options && lot.active_options.length !== 0) {
            _.each(lot.active_options, function(active) {
                var inlist = $filter('filter')($scope.trade_options.options, {
                    'number': active.number }, true);

                var option_lot = [];

                if(inlist.length === 1 && inlist[0].lots) {
                    option_lot = $filter('filter')(inlist[0].lots, {
                        'lot': lot.number, 'phase': lot.phase}, true);
                    lot.total += (option_lot.length === 1)?option_lot[0].cost:0;
                } else {
                    console.log('problem with option ' + active.number);
                }
            });
        }
    };

    $scope.buildCurrentOptions = function(use_lots) {
        var options = [];
        var bids = $filter('filter')($scope.trade_bids, {
                        'trade': $scope.user.trade[0] }, true);

        _.each($scope.trade_options.options, function(option) {
            option.lots = [];
            _.each($scope.selectedItem.lots, function(lot) {
                var opt = $filter('filter')(option.lots, {
                    'number': option.number, 
                    'lot': lot.number, 
                    'phase': lot.phase,
                    'plan': lot.plan }, true);

                if(opt.length === 0) {
                    if(option.plans.indexOf(lot.plan) !== -1) {
                        var actOpt = $filter('filter')(lot.active_options, {
                            'number': option.number}, true)[0];
                        var tradeTot = null;
                        if(!actOpt) {
                            console.log('we dont have the active option on the lot');
                        } else {
                            tradeTot = $filter('filter')(actOpt.totals, {
                                'trade': $scope.my_trade.trade }, true)[0];
                        }

                        option.lots.push({
                            name: option.name,
                            number: option.number,
                            phase: lot.phase,
                            lot: lot.number,
                            plan: lot.plan,
                            has_multiple: option.has_multiple,
                            // multiple: (tradeTot)?tradeTot.multiple:1,
                            // option_revision: (tradeTot)?tradeTot.option_revision:1,
                            active: $scope.doesLotHaveOption(lot, option)
                        });

                        if(option.lots[option.lots.length-1].active) {
                            option.lots[option.lots.length-1].cost = 
                                $scope.getLotOptionTotal(lot, option, bids[0]);
                        } else {
                            option.lots[option.lots.length-1].cost = 0;
                        }

                    } else {
                        option.lots.push({
                            name: 'NO DATA',
                            number: option.number,
                            phase: lot.phase,
                            lot: lot.number,
                            plan: 'NA'
                        });
                    }
                } else if(opt.length === 1) {
                    toaster.pop('error', 'Building Options', 
                        'Found a lot/plan combo in list. Contact Admin.');
                    return;
                }
            });
        });

        //$scope.ordered_lots = $filter('orderBy')($scope.selectedItem.lots, ['phase', 'number']);
    };

    $scope.getMultipleValue = function(lot, option) {
        if(!lot || lot.has_multiple) return;

        var lot_mult = $filter('filter')($scope.selectedItem.lots, {
            'number': lot.lot, 'phase': lot.phase }, true)[0];
        if(!lot_mult) {
            //console.log('could not find project lot!!!');
            return;
        }
        var act_mult = $filter('filter')(lot_mult.active_options, {
            'number': option.number }, true)[0];

        var trade_mult = null;

        if(!act_mult || !act_mult.totals) {
            //console.log('could not find an active option for this lot');
            return;
        } else {
            trade_mult = $filter('filter')(act_mult.totals, {
                'trade': $scope.user.trade[0] }, true)[0];

            if(!trade_mult) {
                //console.log('could not find a trade entry for this lot');
                return;
            }
        }

        return trade_mult.multiple;
    }

    //this was put in to use from the html (ng-init="curLot=getLotData(itme,lot)")
    //but adding number to the lot data seems to have fixed the problem.
    //keeping here just in case i have to go back.
    $scope.getLotData = function(opt, lot) {
        var option = $filter('filter')($scope.trade_options.options, {'number': opt.number}, true)[0];
        return $filter('filter')(option.lots, {
            'number':opt.number, 'lot': lot.lot,'phase': lot.phase, 'plan': lot.plan}, true)[0];
    }
 
    $scope.doesLotHaveOption = function(lot, option) {
        var proj_lot = $filter('filter')($scope.selectedItem.lots, {
            'number': lot.number, 'phase': lot.phase, 'plan': lot.plan }, true);
        if(proj_lot.length !== 1) {
            toaster.pop('error', 'Project Lot Info', 
                'Expected to get lot info but did not.');
            return;
        }

        return $filter('filter')(proj_lot[0].active_options, {
            'number': option.number }, true).length !== 0;
    };

    $scope.getLotOptionTotal = function(lot, option, bid) {
        //this is an active option but we need to get revision number
        var lotTmp = $filter('filter')(lot.active_options, {'number': option.number}, true)[0];
        if(!lotTmp) {
            console.log('PROBLEMS');
            return;
        }

        if(!lotTmp.totals) return;

        //used to get option revision but not always valid
        var tradeTmp = $filter('filter')(lotTmp.totals, {'trade': $scope.user.trade[0]}, true)[0];

        return (tradeTmp)?tradeTmp.total:0;
    };

    $scope.removeLotBidTaskRecords = function(item, subtasks, lot) {
        var subtask = subtasks.splice(0, 1);
        if(subtask.length > 0) {
            var code = subtask[0].code;
            //var bid_task = $filter('filter')
            console.log('I should remove ' + lot.phase + '/' + lot.lot + '/' + code);
            var bid_task = $filter('filter')($scope.bid_tasks, {
                'lot': lot.lot, 'phase': lot.phase, 'task_code': code }, true);

            if(bid_task.length == 1) {
                bid_task = bid_task[0]
                var idx = $scope.bid_tasks.indexOf(bid_task);

                console.log('Deleting bid task specific record ' + bid_task._id + 
                    ' for ' + lot.phase + '/' + lot.lot + '/' + code);
                bid_task.$delete(function(success) {
                    $scope.bid_tasks.splice(idx, 1);

                    var original_bid = [];
                    if(bid_task.revision) {
                        original_bid = $filter('filter')($scope.bid_tasks, {'plan_code':bid_task.plan_code, 
                            'task_code': code, 'revision': bid_task.revision }, true);
                    } else {
                        original_bid = $filter('filter')($scope.bid_tasks, {'plan_code':bid_task.plan_code, 
                            'task_code': code, 'latest': true }, true);
                    }

                    if(original_bid.length == 1) {
                        original_bid = original_bid[0]
                    } else {
                        console.log('WE HAVE A PROBLEM FINDING THE ORIGINAL BID TASK RECORD');
                    }

                    var task = $filter('filter')($scope.project_tasks, {
                        'project_bid_id': success._id }, true);

                    if(task.length !== 1) {
                        toaster.pop('error', 'Task Association Error',
                            'Cannot find the original ProjectBid.  This needs to be fixed for job costing.');
                    } else {
                        var task_idx = $scope.project_tasks.indexOf(task[0]);
                        //update the ProjectTask
                        task[0].project_bid_id = original_bid._id;
                        console.log('Updating ProjectTask record ' + task[0]._id + 
                            ' (' + task[0].task_code + ') because of a bid record reset');
                        
                        task[0].$update(function(ret_val) {
                            console.log('Replacing task ' + $scope.project_tasks[task_idx]._id + 
                                ' with currently updated task ' + ret_val._id);
                            $scope.project_tasks.splice(task_idx, 1, ret_val);

                            console.log('Reapplying option because this was just a delete process');
                            $scope.removeLotBidTaskRecords(item, subtasks, lot);
                        }, function(error) {
                            toaster.pop('error', 'THIS Task Update Error', error);
                        });
                    }
                }, function(error) {
                    toaster.pop('error', 'Bid Task Delete Error', error);
                });

            }
        } else {
            console.log('no more codes to remove...now to update as needed');
            $scope.updateLotOption(item, lot, false, false, true);
        }
    }

    $scope.updateLotOptionOperation = function(item, lot, active) {
        var multiple_value = $scope.getMultipleValue(lot, item);

        if(active) {
            $scope.multiple_options = {
                'item': item,
                'lot': lot,
                'active': active
            };

            lot.multiple = 1;
            $scope.multiple_options.item.revision = $scope.multiple_options.item.revisions.length;

            if(item.has_multiple) {
                ngDialog.openConfirm({
                    template: 'projects/views/project/multiple.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default'
                }).then(function (value) {
                    $scope.multiple_options.item.multiple = $scope.multiple_options.lot.multiple;
                    $scope.updateLotOption($scope.multiple_options.item, 
                        $scope.multiple_options.lot, $scope.multiple_options.active, true, true);
                }, function (value) {
                    //Do something 
                    $scope.multiple_options.active = false;
                    $scope.multiple_options.lot.active = false;
                    console.log('in the do something section');
                });
            } else {
                $scope.multiple_options.item.multiple = 1;
                $scope.updateLotOption($scope.multiple_options.item, 
                    $scope.multiple_options.lot, $scope.multiple_options.active, true, true);
            }
        } else {
            var lotItem = $filter('filter')($scope.selectedItem.lots, {
                'phase': lot.phase, 'number': lot.lot }, true)[0];

            var optItem = $filter('filter')(lotItem.active_options, {
                'number': item.number }, true)[0];

            var myOpt = $filter('filter')(optItem.totals, {'trade': $scope.my_trade.trade }, true)[0];

            item.revision = $filter('filter')(item.revisions, {'number': myOpt.option_revision}, true)[0];

            $scope.multiple_options = {
                'item': item,
                'lot': lot,
                'active': active
            };

            //$scope.multiple_options.item.revision = $scope.multiple_options.item.revisions[0];

            lot.multiple = item.multiple = multiple_value;

            ngDialog.openConfirm({
                template: 'projects/views/project/deselect_lot.html',
                scope: $scope,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                // value === 1 is unselect the option
                // value === 2 is modify the option
                console.log(value);
                if(value === 1) {
                    item.multiple = 1;
                    lot.multiple = 1;

                    var option_subtasks = $filter('filter')(item.subtasks, {'revision': item.revision.number});
                    var subtasks = $filter('unique')(option_subtasks, 'code');

                    $scope.removeLotBidTaskRecords(item, subtasks, lot);

                    //$scope.updateLotOption(item, lot, active, false, true);
                } else if(value === 2) {
                    //$scope.updateLotOption(item, lot, active, false, true);

                    lot.active = true;
                    active = true;
                    $scope.multiple_options.active = true;
                    $scope.multiple_options.lot.active = true;

                    var projLot = $filter('filter')($scope.selectedItem.lots, {
                        'number': $scope.multiple_options.lot.lot, 
                        'phase': $scope.multiple_options.lot.phase }, true)[0];
                    var opt = $filter('filter')(projLot.active_options, {'number': item.number}, true)[0];
                    _.remove(opt.totals, function(tot) {
                        return tot.trade === $scope.my_trade.trade;
                    });

                    $scope.multiple_options.lot.cost = 0;
                    var updateLot = $filter('filter')($scope.multiple_options.item.lots, {
                        'lot': $scope.multiple_options.lot.lot, 
                        'phase': $scope.multiple_options.lot.phase }, true)[0];
                    updateLot.cost = 0;

                    if($scope.multiple_options.item.revision.number) {
                        $scope.multiple_options.item.revision = $scope.multiple_options.item.revision.number;
                    }

                    $scope.multiple_options.item.multiple = $scope.multiple_options.lot.multiple;
                    $scope.updateLotOption($scope.multiple_options.item, 
                        $scope.multiple_options.lot, $scope.multiple_options.active, true, true);
                }
            }, function (value) {
                lot.active = true;
                //Do something 
                // $scope.multiple_options.active = false;
                // $scope.multiple_options.lot.active = false;
                console.log('in the do something section' + value);
            });

            //$scope.updateLotOption(item, lot, active, false, true);
        }
    };

    $scope.updateOptionRecord = function(item, options_to_apply, active, lot, proj_lot) { 
        var original_bid = options_to_apply.splice(0, 1);
        console.log("+++++++++++++++updateOptionRecord print start++++++++++++++++++++++");
        if(original_bid.length > 0) {
            original_bid = original_bid[0];
            var bid_task = $filter('filter')($scope.bid_tasks, {
                'lot': lot.lot, 'phase': lot.phase, 'task_code': original_bid.task_code }, true);

            if(bid_task.length > 1) {
                console.log('Found more than one bid_task ' + bid_task.length);
                bid_task = bid_task[0];
            } else if(bid_task.length == 1) {
                bid_task = bid_task[0];
                console.log('Found exactly one bid task to work with');
            } else {
                console.log('DID NOT find any bid_task to work on for ' +
                    lot.lot + '/' + lot.phase + '/' + original_bid.task_code + '.');
                bid_task = null;
            }
            var bid = angular.copy(original_bid);
            var task = {
                'plan_code': lot.plan,
                'task_code': bid.task_code,
                'lot': lot.lot,
                'phase': lot.phase
            }

            //first remove all options that have been added to the task
            //there may be some options that are modifications that will
            //be dealt with later.
            if(bid_task) {
                _.remove(bid_task.subtasks, function(sub) {
                    return sub.is_option === true && sub.is_original === false;
                });

                _.remove(bid_task.materials, function(mat) {
                    return mat.is_option === true && mat.is_original === false;
                });

                _.remove(bid_task.equipment, function(equip) {
                    return equip.is_option === true && equip.is_original === false;
                });
            }

            if(!active) {
                console.log('This is an inactive process');
                if(bid_task) {
                    console.log("We have a bid_task " + bid_task.task_code + " to remove");
                    _.each(bid_task.subtasks, function(sub) {
                        _.remove(sub.multi_data, function(mult) {
                            return mult.option_number === item.number;
                        });
                    });
                    _.remove(bid_task.materials, function(sub) {
                        return sub.option_number === item.number;
                    });
                    _.remove(bid_task.equipment, function(sub) {
                        return sub.option_number === item.number;
                    });
                }
            }

            var remove_bid_task = false;
            if(bid_task) {
                var opt_subs = $filter('filter')(bid_task.subtasks, {'is_option': true}, true);
                _.remove(opt_subs, function(sub) {
                    return sub.multi_data.length === 0;
                });
                
                var opt_mat = $filter('filter')(bid_task.materials, {'is_option': true}, true);
                var opt_eq = $filter('filter')(bid_task.equipment, {'is_option': true}, true);
                if(opt_subs.length === 0 && opt_mat.length === 0 && opt_eq.length === 0) {
                    remove_bid_task = true;
                }
            }

            //does this task need to be removed
            if(remove_bid_task || proj_lot[0].active_options.length === 0) {
                var idx = $scope.bid_tasks.indexOf(bid_task);
                if(idx !== -1) {
                    console.log('In the delete bid task specific record section that no longer does anything');
                    bid_task.$delete(function(success) {
                        $scope.bid_tasks.splice(idx, 1);

                        var task = $filter('filter')($scope.project_tasks, {
                            'project_bid_id': success._id }, true);

                        if(task.length !== 1) {
                            toaster.pop('error', 'Task Association Error',
                                'Cannot find the original ProjectBid.  This needs to be fixed for job costing.');
                        } else {
                            var task_idx = $scope.project_tasks.indexOf(task[0]);
                            //update the ProjectTask
                            task[0].project_bid_id = original_bid._id;
                            console.log('Updating ProjectTask record ' + task[0]._id + 
                                ' (' + task[0].task_code + ') because of a bid record reset');
                            console.log(item);
                            task[0].$update(function(ret_val) {
                                console.log('Replacing task ' + $scope.project_tasks[task_idx]._id + 
                                    ' with currently updated task ' + ret_val._id);
                                $scope.project_tasks.splice(task_idx, 1, ret_val);

                                console.log('Reapplying option because this was just a delete process');
                                options_to_apply.unshift(original_bid);
                                $scope.updateOptionRecord(item, options_to_apply, active, lot, proj_lot);
                            }, function(error) {
                                toaster.pop('error', 'THIS Task Update Error', error);
                            });
                        }

                    }, function(error) {
                        toaster.pop('error', 'Bid Task Delete Error', error);
                    });
                } else {
                    console.log("----------------In the inner else statement--------------------");

                    if(options_to_apply.length > 0) {
                        $scope.updateOptionRecord(item, options_to_apply, active, lot, proj_lot);
                    } else {
                        console.log("+_+_+_+_+_All options removed_+_+_+_+_+");
                        $scope.show_spinner = false;
                    }
                }
            } else {
                if(!bid_task) {
                    if(!active) {
                        for(var i=0; i<proj_lot[0].active_options.length; i++) {
                            var curr_opt = proj_lot[0].active_options[i];
                            var opt = $filter('filter')($scope.trade_options.options, {'number':curr_opt.number}, true)[0];
                            var opt_subs = $filter('filter')(opt.subtasks, {'code': original_bid.task_code, 
                                'revision': original_bid.revision}, true);
                            if(opt_subs.length > 0) {
                                console.log(original_bid.task_code + ' is available on option ' + curr_opt.number +
                                    ' so we need to go ahead and build that task');

                                bid_task = angular.copy(original_bid)
                                bid_task.lot = lot.lot;
                                bid_task.phase = lot.phase;
                                bid_task.has_options = true;
                                bid_task.original_totals = original_bid.totals;
                                delete bid_task._id;
                                bid_task.save_as_new = true;
                                break;
                            }
                        }
                    } else {
                        bid_task = angular.copy(original_bid)
                        bid_task.lot = lot.lot;
                        bid_task.phase = lot.phase;
                        bid_task.has_options = true;
                        bid_task.original_totals = original_bid.totals;
                        delete bid_task._id;
                        bid_task.save_as_new = true;
                    }
                } else {
                    bid_task.save_as_new = false;
                }

                if(bid_task) {
                    console.log('Before Clear Task ' + original_bid.task_code + ' Totals: ');
                    console.log('\tOriginal Total: ' + original_bid.totals.total);
                    console.log('\tBid Total: ' + bid_task.totals.total);
                    $scope.clearBidTaskTotals(bid_task, original_bid);

                    console.log('Before Active Task ' + original_bid.task_code + ' Totals: ');
                    console.log('\tOriginal Total: ' + original_bid.totals.total);
                    console.log('\tBid Total: ' + bid_task.totals.total);
                    $scope.playActiveOptionsOnBid(item, lot, proj_lot[0], [bid], bid_task);

                    console.log('Before Update Task ' + original_bid.task_code + ' Totals: ');
                    console.log('\tOriginal Total: ' + original_bid.totals.total);
                    console.log('\tBid Total: ' + bid_task.totals.total);
                    $scope.updateBidTaskTotals(bid_task);

                    console.log('After Update Task ' + original_bid.task_code + ' Totals: ');
                    console.log('\tOriginal Total: ' + original_bid.totals.total);
                    console.log('\tBid Total: ' + bid_task.totals.total);

                    if(!bid_task.save_as_new) {
                        var idx = $scope.bid_tasks.indexOf(bid_task);
                        if(idx !== -1) {
                            //bid._id = $scope.bid_tasks[idx]._id;
                            console.log('Updating bid task ' + bid_task._id);
                            bid_task.$update(function(success) {
                                console.log('Replacing bid ' + $scope.bid_tasks[idx]._id + 
                                    ' with currently updated bid ' + success._id);
                                $scope.bid_tasks.splice(idx, 1, success);
                                $scope.updateOptionRecord(item, options_to_apply, active, lot, proj_lot);
                            }, function(error) {
                                toaster.pop('error', 'Bid Task Update Error', error);
                            });
                        }
                    } else if(bid_task.save_as_new) {
                        console.log('saving bid task');
                        bid_task.$save(function(success) {
                            console.log('got an id of ' + success._id + ' after save.');
                            var task = $filter('filter')($scope.project_tasks, {
                                'phase': success.phase, 'lot': success.lot, 'task_code': success.task_code}, true);

                            if(task.length !== 1) {
                                toaster.pop('error', 'Task Association Error',
                                    'Cannot find the task.  This needs to be fixed for job costing.');
                            } else {
                                var task_idx = $scope.project_tasks.indexOf(task[0]);
                                //update the ProjectTask
                                task[0].project_bid_id = success._id;
                                console.log('Updating ProjectTask record ' + task[0]._id);
                                console.log(item);
                                task[0].$update(function(ret_val) {
                                    console.log('Replacing task ' + $scope.project_tasks[task_idx]._id + 
                                        ' with currently updated task ' + success._id);
                                    $scope.project_tasks.splice(task_idx, 1, ret_val);
                                    $scope.bid_tasks.push(success);

                                    $scope.updateOptionRecord(item, options_to_apply, active, lot, proj_lot);
                                }, function(error) {
                                    toaster.pop('error', 'ANOTHER Task Update Error', error);
                                });
                                // $scope.bid_tasks.push(success);

                                // $scope.updateOptionRecord(item, options_to_apply, active, lot, proj_lot);
                            }
                        }, function(error) {
                            toaster.pop('error', 'Bid Task Save Error', error);
                        });
                    } else {
                        $scope.updateOptionRecord(item, options_to_apply, active, lot, proj_lot);
                    }
                } else {
                    $scope.updateOptionRecord(item, options_to_apply, active, lot, proj_lot);
                }
            }
            //console.log(bid);
        } else {
            console.log("----------------In the else statement--------------------");
            $scope.show_spinner = false;
        }
    };

    $scope.updateLotOption = function(item, lot, active, is_multiple, update_project) {
        //first find the lot
        var proj_lot = $filter('filter')($scope.selectedItem.lots, {
            'number': lot.lot, 'phase': lot.phase, 'plan': lot.plan }, true);

        if(proj_lot.length !== 1) {
            toaster.pop('error', 'Project Lot Info', 
                'Expected to get lot info but did not.');
            return;
        }

        if(!proj_lot[0].revision) {
            proj_lot[0].revision = $filter('filter')(proj_lot[0].revisions, {'trade': $scope.my_trade.trade}, true);

            if(proj_lot[0].revision.length == 1) {
                proj_lot[0].revision = proj_lot[0].revision[0].revision;
            }
        }

        let current = proj_lot[0].revision === $scope.revisions.length;
        let option_revision = (item.revision.number)?item.revision.number:item.revision;

        let bid_tasks = $filter('filter')($scope.bid_tasks, {'plan_code': lot.plan}, true);
        let option_subtasks = $filter('filter')(item.subtasks, {'plan': lot.plan, 'revision': option_revision}, true);
        let unique_tasks = $filter('unique')(option_subtasks, 'code');

        let multiple = item.multiple;

        //list of projectBid records that need to be modified for the current option selection
        let modified_bid_tasks = [];
        _.each(unique_tasks, function(task) {
            let items = []; 
            if(current) {
                items = $filter('filter')(bid_tasks, {
                    'task_code': task.code, 'latest': true}, true);
            } else {
                items = $filter('filter')(bid_tasks, {
                    'task_code': task.code, 'revision': proj_lot[0].revision}, true);
            }
            _.each(items, function(item) {
                modified_bid_tasks.push(item);
            });
        });

        let lot_cost = 0;

        if(active) {
            let opt_cost = $filter('filter')($scope.matrix_values, {'number': item.number}, true)[0];
            if(opt_cost) {
                opt_cost = $filter('filter')(opt_cost.plans, {'plan': lot.plan}, true)[0];
                if(opt_cost) {
                    opt_cost.value = opt_cost.option - opt_cost.original;
                    opt_cost.value *= (multiple)?multiple:1;
                    lot_cost = opt_cost.value;
                }
            }

            //this will remove a modify
            _.remove(proj_lot[0].active_options, function(opt) {
                return opt.name === item.name && opt.number === item.number;
            });

            proj_lot[0].active_options.push({
                'name': item.name,
                'number': item.number,
                'totals': [{
                    'multiple': (multiple)?multiple:1,
                    'option_revision': option_revision,
                    'trade': modified_bid_tasks[0].trade,
                    'total': (opt_cost)?opt_cost.value:0
                }]
            })
        } else {
            _.remove(proj_lot[0].active_options, function(opt) {
                return opt.name === item.name && opt.number === item.number;
            });
        }

        var original_bid_task = _.remove(modified_bid_tasks, function(bidt) {
            return !bidt.phasee && !bidt.lot;
        });

        $scope.show_spinner = true;

        $scope.updateOptionRecord(item, original_bid_task, active, lot, proj_lot);

        //update the trade option so it will update the view
        var update_option_lot = $filter('filter')($scope.trade_options.options, {
            'number': item.number}, true);
        if(update_option_lot.length !== 1) {
            console.log('Could not find the option so you must refresh to see the total');
        } else {
            update_option_lot = $filter('filter')(update_option_lot[0].lots, {
                'lot': lot.lot, 'phase': lot.phase}, true)[0];

            if(update_option_lot) {
                update_option_lot.cost = lot_cost;
            }
        }

        $scope.selectedItem.$update(function(proj_result) {
            $scope.selectedItem = proj_result;
            var original_lot = $filter('filter')($scope.selectedItem.lots, {
                'phase': proj_lot[0].phase, 'number': proj_lot[0].number }, true)[0];

            if(!original_lot) {
                toaster.pop('error', 'Lot Not Found');
            } else {
                var update_lot = $filter('filter')($scope.ordered_lots, {
                    'phase': proj_lot[0].phase, 'number': proj_lot[0].number }, true)[0];

                if(!update_lot) {
                    toaster.pop('error', 'Lot Not Found');
                } else {
                    update_lot.active_options = original_lot.active_options;
                }
            }

            _.each($scope.ordered_lots, function(lot) {
                $scope.getOptionTotal(lot);
            });

            toaster.pop('success', 'Saving Project', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Saving Project', error);
        });
    };

    $scope.clearBidTaskTotals = function(bid_task, original) {
        bid_task.totals.current_net_pay = original.totals.current_net_pay;
        bid_task.totals.equipment = original.totals.equipment;
        bid_task.totals.equipment_dev_subtotal = original.totals.equipment_dev_subtotal;
        bid_task.totals.equipment_subtotal = original.totals.equipment_subtotal;
        bid_task.totals.general_liability = original.totals.general_liability;
        bid_task.totals.hours_allowed = original.totals.hours_allowed;
        bid_task.totals.labor = original.totals.labor;
        bid_task.totals.mark_up = original.totals.mark_up;
        bid_task.totals.materials = original.totals.materials;
        bid_task.totals.materials_dev_subtotal = original.totals.materials_dev_subtotal;
        bid_task.totals.materials_subtotal = original.totals.materials_subtotal;
        bid_task.totals.work_comp = original.totals.work_comp;
        bid_task.totals.total = original.totals.total;
        _.each(bid_task.subtasks, function(sub, idx) {
            if(original.subtasks[idx]) {
                sub.current_net_pay = original.subtasks[idx].current_net_pay;
                sub.equipment_total = original.subtasks[idx].equipment_total;
                sub.equipment_dev_subtotal = original.subtasks[idx].equipment_dev_subtotal;
                sub.equipment_subtotal = original.subtasks[idx].equipment_subtotal;
                sub.general_liability = original.subtasks[idx].general_liability;
                sub.hours_allowed = original.subtasks[idx].hours_allowed;
                sub.labor_total = original.subtasks[idx].labor_total;
                sub.mark_up = original.subtasks[idx].mark_up;
                sub.material_total = original.subtasks[idx].material_total;
                sub.materials_dev_subtotal = original.subtasks[idx].materials_dev_subtotal;
                sub.materials_subtotal = original.subtasks[idx].materials_subtotal;
                sub.work_comp = original.subtasks[idx].work_comp;
                sub.total = original.subtasks[idx].total;
                sub.quantity = original.subtasks[idx].quantity;
            }
        });
    };

    $scope.updateBidTaskTotals = function(bid_task) {
        bid_task.totals.current_net_pay = 0;
        bid_task.totals.equipment = 0;
        bid_task.totals.equipment_dev_subtotal = 0;
        bid_task.totals.equipment_subtotal = 0;
        bid_task.totals.general_liability = 0;
        bid_task.totals.hours_allowed = 0;
        bid_task.totals.labor = 0;
        bid_task.totals.mark_up = 0;
        bid_task.totals.material = 0;
        bid_task.totals.materials_dev_subtotal = 0;
        bid_task.totals.materials_subtotal = 0;
        bid_task.totals.work_comp = 0;
        bid_task.totals.total = 0;
        _.each(bid_task.subtasks, function(sub) {
            bid_task.totals.current_net_pay += sub.current_net_pay;
            bid_task.totals.equipment += (sub.equipment_total)?sub.equipment_total:0;
            bid_task.totals.equipment_dev_subtotal += 
                (sub.equipment_dev_subtotal)?sub.equipment_dev_subtotal:0;
            bid_task.totals.equipment_subtotal += 
                (sub.equipment_subtotal)?sub.equipment_subtotal:0;
            bid_task.totals.general_liability += sub.general_liability;
            bid_task.totals.hours_allowed += sub.hours_allowed;
            bid_task.totals.labor += sub.labor_total;
            bid_task.totals.mark_up += sub.bid_mark_up;
            bid_task.totals.materials += (sub.material_total)?sub.material_total:0;
            bid_task.totals.materials_dev_subtotal += 
                (sub.materials_dev_subtotal)?sub.materials_dev_subtotal:0;
            bid_task.totals.materials_subtotal += 
                (sub.materials_subtotal)?sub.materials_subtotal:0;
            bid_task.totals.work_comp += sub.work_comp;
            if(sub.is_overridden) {
                bid_task.totals.total += sub.overridden_total;
            } else {
                bid_task.totals.total += sub.total;
            }
        });
    };

    $scope.playActiveOptionsOnBid = function(item, lot, lot_info, bids, task) {
        if(lot_info.active_options.length === 0) return;

        var changes_made = false;
        var new_bid_tasks = [];
        var return_bid = [];

        var trades_array = $filter('filter')($scope.selectedItem.trades, {
            'name': $scope.my_trade.trade }, true);

        var lotRevision = $filter('filter')(trades_array[0].revisions, {
            'number': lot_info.revision }, true)[0];

        var costs = trades_array[0].company_factors;

        if(lotRevision) {
            costs = lotRevision.company_factors;
        }

        _.each(lot_info.active_options, function(option) {
            var my_opt = $filter('filter')($scope.trade_options.options, {
                'number': option.number}, true)[0];

            var tradeInfo = $filter('filter')(option.totals, {
                'trade': $scope.user.trade[0] }, true)[0];

            if(tradeInfo) {
                var subtasks = $filter('filter')(my_opt.subtasks, {
                    'code': task.task_code, 'plan': task.plan_code}, true);
                subtasks = $filter('filter')(subtasks, {
                    'revision': tradeInfo.option_revision}, true);

                _.each(subtasks, function(subtask) {
                    //remove materials and equipment that have been zeroed out
                    _.remove(subtask.materials, function(mat) {
                        return mat.quantity === 0;
                    });
                    _.remove(subtask.equipment, function(equip) {
                        return equip.quantity === 0;
                    });
                    //var bid_subtask = task.subtasks[subtask.subtask_array_id];
                    //var original_subtask = bids[0].subtasks[subtask.subtask_array_id];

                    taskTotalsService.getSubtaskCalculations([subtask], costs);
                    // taskTotalsService.getSubtaskCalculations([original_subtask], costs);
                    // taskTotalsService.getSubtaskCalculations([bid_subtask], costs);

                    var mult_value = $filter('filter')(option.totals, {'trade': task.trade}, true)[0];
                    if(!mult_value) {
                        mult_value = {
                            multiple: 1
                        }
                    }

                    if(subtask.bid_subtask) {
                        console.log('adding bid subtask ' + subtask.name + ' to task ' + subtask.code +
                            ' for option ' + item.number);
                        projectOptionService.updateProjectBidSubtaskFromOptionAndOriginal(
                            option, lot, subtask, task, bids[0], costs,
                            subtask.subtask_array_id, mult_value.multiple);
                    } else {
                        //this is a system subtask and we just add it
                        option.lot = (lot.lot)?lot.lot:lot.number,
                        option.phase = lot.phase;
                        option.is_multiple = (mult_value.multiple>1)?true:false;
                        option.multiple = mult_value.multiple;
                        console.log('adding system subtask ' + subtask.name + ' to task ' + subtask.code +
                            ' for option ' + item.number);

                        // this subtask is not part of the project bid
                        // so just add it's information
                        projectOptionService.addProjectBidSubtaskFromSubtask(subtask, task, option);
                    }
                });
            } else {
                console.log('this might not be an error but we did not get trade totals.');
            }
        });

        return changes_made;
    };

    $scope.removeProjectBid = function(bid_task) {
        var index = $scope.bid_tasks.indexOf(bid_task);

        if(index !== -1) {
            bid_task.$delete(function(success) {
                $scope.bid_tasks.splice(index, 1);
                toaster.pop('success', 'Project Bid Record Removed');
            }, function(error) {
                toaster.pop('error', 'Project Bid Remove Error', error);
            });
        }
    };

    $scope.removeProjectBidOperation = function(bid_task) {
        ngDialog.openConfirm({
            template: 
                '<h2>Delete Project Bid Record</h2>' +
                '<p>This will remove ' + bid_task.task_name + ' from this project.</p>' +
                '<p>This operation cannot be undone </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            $scope.removeProjectBid(bid_task);
        }, function (value) {
            //Do something 
            console.log('in the do something section');
        });
    };

    $scope.removeOptionSubtask = function(current_option, subtask) {
        var opt_idx = $scope.trade_options.options.indexOf(current_option);

        if(opt_idx === -1) {
            toaster.pop('error', 'Option Not Found');
            return;
        }

        var index = $scope.trade_options.options[opt_idx].subtasks.indexOf(subtask);

        if(index !== -1) {
            $scope.trade_options.options[opt_idx].subtasks.splice(index, 1);

            $scope.trade_options.$update(function(success) {
                //$scope.bid_tasks.splice(index, 1);
                $scope.trade_options = success;
                toaster.pop('success', 'Option Subtask Removed');
            }, function(error) {
                toaster.pop('error', 'Option Subtask Remove Error', error);
            });
        }
    };

    $scope.removeOptionSubtaskOperation = function(current_option, subtask) {
        ngDialog.openConfirm({
            template: 
                '<h2>Delete Option Subtask</h2>' +
                '<p>This will remove ' + subtask.name + ' from this option.</p>' +
                '<p>This operation cannot be undone </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            $scope.removeOptionSubtask(current_option, subtask);
        }, function (value) {
            //Do something 
            console.log('in the do something section');
        });
    };

    $scope.setTrades = function() {
        $scope.selectedTrade = $scope.trade_bids;
    };

    $scope.add_option = {
        has_multiple: false
    }

    $scope.addOption = function() {
        if(!this.add_option) {
            toaster.pop('error', 'Add Option', 'Nothing entered.');
            return;
        }
        if(!this.add_option.number) {
            toaster.pop('error', 'Add Option', 'Number not entered.');
            return;
        }
        if(!this.add_option.name) {
            toaster.pop('error', 'Add Option', 'Name not entered.');
            return;
        }
        if(!this.add_option.plans) {
            toaster.pop('error', 'Add Option', 'No plan selected.');
            return;
        }

        if(!this.add_option.has_multiple) {
            this.add_option.has_multiple = false;
        }

        if ($scope.trade_options.options.filter(e => e.number == this.add_option.number).length == 0) {
            var trades = [];
            var plans = [];

            for(var i=0; i<this.add_option.plans.length; i++) {
                  plans.push(this.add_option.plans[i].item);
            }

            var new_option = {
                number: this.add_option.number,
                name: this.add_option.name,
                description: this.add_option.description,
                has_multiple: this.add_option.has_multiple,
                trades: $scope.user.trade[0],
                bid_revision: $scope.revisions.length,
                revisions: {
                    number: 1
                },
                plans: plans
            };

            $scope.trade_options.options.push(new_option);

            $scope.trade_options.$update(function(success) {
                // need to keep the bid in sync with changes
                //$scope.trade_options = success;
                $rootScope.$broadcast('$addToBidOptions', new_option);
            }, function(failure) {
                toaster.pop('error', 'Project Save', failure);
                return;
            });

            this.add_option.number =
            this.add_option.name =
            this.add_option.description = 
            this.add_option.trades =
            this.add_option.plans = '';
            this.add_option.has_multiple = false;
        } else {
            toaster.pop('error', 'Unique Code', 'Code Already Exists.');
        }
    };

    $scope.removeOption = function(idx) {
        var isActive = $filter('filter')($scope.trade_options.options[idx].lots, {'active': true}, true);

        if(isActive.length > 0) {
            toaster.pop('error', 'Active Option On Lot',
                'This option is active for a lot.  Deselect in Per Lot Select.');
            return;
        }

        $scope.trade_options.options.splice(idx, 1);

        $scope.trade_options.$update(function(success) {
            //$scope.selectedItem.$update(function(success) {
                $rootScope.$broadcast('$removeFromBidOptions', idx);
            // }, function(failure) {
            //     toaster.pop('error', 'Project Save', failure);
            //     return;
            // });
        }, function(error) {
            toaster.pop('error', 'Trade Option', error);
        });
    };

    $scope.setOptionNameEditId =  function(item, idx) {
        $scope.optionNameEditId = item._id;

        $scope.current_bid_revision = $filter('filter')($scope.revisions, {
            'number': item.bid_revision }, true)[0];

        $scope.savedOptionCopy = angular.copy(item);
        $scope.savedOptionIndex = idx;
    };

    $scope.cancelOption = function(item) {
        $scope.optionNameEditId = -1;
        $scope.trade_options.options.splice(
            $scope.savedOptionIndex, 1, $scope.savedOptionCopy);
    };

    $scope.updateOption =  function(item) {
        var active = $filter('filter')(item.lots, {'active': true}, true);
        if(active && active.length !== 0) {
            toaster.pop('error', 'Option Is Active', 
                'Deactivate this lot option in PER LOT SELECT to make changes.');

            $scope.optionNameEditId = -1;
        } else {
            var save = true;
            //if the original plans and item.plans do not match
            //up, then we need to remove all subtasks for this option
            if($scope.savedOptionCopy.plans.length !== item.plans.length) {
                save = false;
            } else {
                _.each($scope.savedOptionCopy.plans, function(plan, idx) {
                    if(plan !== item.plans[idx]) {
                        save = false;
                    }
                });
            }

            item.bid_revision = $scope.current_bid_revision.number;

            if(!save) {
                item.subtasks = [];
            }

            $scope.trade_options.$update(function(success) {
                $scope.trade_options = success;
                toaster.pop('success', 'Trade Option Updated');
                $scope.optionNameEditId = -1;
                $scope.buildCurrentOptions();
                $scope.matrix_values = [];

                $scope.matrix_values = optionPlanService.buildAndTotalPlans(
                    $scope.trade_options.options,
                    $scope.selectedItem.plan_codes, $scope.matrix_values, 
                    $scope.trade_bids[0].bid_list, $scope.user.trade[0]);

                _.each($scope.ordered_lots, function(lot) {
                    $scope.getOptionTotal(lot);
                })
                $rootScope.$broadcast('$updateOptionName', success);
            }, function(error) {
                toaster.pop('error', 'Trade Option', error);
            });
        }
    };

    $scope.addOptionsToProject = function() {
        Bids.query({'project_id': $scope.selectedItem._id }, function(bids) {
            if(bids.length !== 1) {
                if($scope.is_builder) {
                    console.log('Need to fix this when we start implementing builders again');
                } else {
                    userService.getMainAccountId($scope.user.username).then(function(id) {
                        Bids.query({ 
                            'project_name': $scope.selectedItem.name }, function(bids) {
                            var bid_list = [];
                            _.each(bids, function(bid) {
                                if(bid.trade_id.main_account_id === id) {
                                    bid_list.push(bid);
                                }
                            })
                            $scope.available_bids = bid_list;
                        });
                    });
                }
            } else {
                $scope.available_bids = bids;
            }
        });
    };

    $scope.associateBidToTrade = function(selected_bid_for_association) {
        var new_option = new Options({
            project_id: $scope.selectedItem._id,
            bid_id: selected_bid_for_association._id
        });

        new_option.$save(function(success) {
            $scope.changeProject()
        }, function(error) {
            toaster.pop('error', 'Option Save Error', error);
        });
    };

    $scope.deleteAllOptions = function() {
        var no_active = true;
        _.each($scope.selectedItem.lots, function(lot) {
            if(lot.active_options.length !== 0) {
                no_active = false;
            }
        });

        if(no_active) {
            $scope.trade_options.options = [];
            $scope.trade_options.$update(function(success) {
                $scope.selectedItem.$update(function(success) {
                    $scope.selectedItem = success;
                    $scope.normalizeLotRevisions();
                    $scope.changeProject();
                    toaster.pop('success', 'Trade Options', 'Databases updated');
                }, function(error) {
                    toaster.pop('error', 'Project Update Error', error);
                    return;
                });
            }, function(error) {
                toaster.pop('error', 'Trade Options Error', error);
                return;
            });
        } else {
            toaster.pop('error', 'Delete Options Error', 
                'Please dactivate all options in PER LOT SELECT prior to deletion');
        }
    };

    $scope.deleteAllOptionsOperation = function() {
        ngDialog.openConfirm({
            template: 
                '<h2>Remove Options Confirm</h2>' +
                '<p>This will remove all options you\'ve created for this project.</p>' +
                '<p>This operation cannot be undone </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            $scope.deleteAllOptions();
        }, function (value) {
            //Do something 
            console.log('in the do something section');
        });
    };

    $scope.ConvertPerLotSelectToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = ' , PHASE';
        var ordered_lots = angular.copy($scope.ordered_lots);
        ordered_lots = $filter('orderBy')(ordered_lots, ['phase', 'number']);
        for(var i=0; i<ordered_lots.length; i++) {
            str += ',' + ordered_lots[i].phase;
        }
        str += '\r\n';

        str += ' , LOT';
        for(var i=0; i<ordered_lots.length; i++) {
            str += ',' + ordered_lots[i].number;
        }
        str += '\r\n';

        str += ' , PLAN';
        for(var i=0; i<ordered_lots.length; i++) {
            str += ',' + ordered_lots[i].plan;
        }
        str += '\r\n';

        for(var i=0; i<array.length; i++) {
            var name = (array[i].name)?array[i].name : '';
            str += array[i].number + ',' + name + ',';
            array[i].lots = $filter('orderBy')(array[i].lots, ['phase', 'lot']);
            for(var j=0; j<array[i].lots.length; j++) {
                if(array[i].lots[j].active) {
                    if(array[i].lots[j].has_multiple) {
                        var lot = $filter('filter')(ordered_lots, {
                            'number': array[i].lots[j].lot, 'phase': array[i].lots[j].phase}, true);
                        if(lot.length !== 1) {
                            toaster.pop('error', 'Getting too many lots for ' + array[i].lots[j].lot 
                                + ', ' + array[i].lots[j].phase);
                            str += 'issue';
                        } else {
                            var option = $filter('filter')(lot[0].active_options, {'number': array[i].number}, true);
                            var trade_opt = $filter('filter')(option[0].totals, {'trade': $scope.user.trade[0]}, true);
                            str += trade_opt[0].multiple;
                        }
                    } else {
                        str += '1';
                    }
                }

                if(j<array[i].lots.length-1)
                    str += ',';
            }
            str += '\r\n';
        }

        return str;
    };

    $scope.exportPerLotSelectFile = function() {
        var dataUrl = 'data:text/csv;utf-8,' + 
            encodeURI($scope.ConvertPerLotSelectToCSV($scope.trade_options.options));
        var link = document.createElement('a');
      
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'options_per_lot_matrix.csv'); // Pretty much only works in chrome
      
        link.click();
    };

    $scope.editColorScheme = function(item) {
        item.colorSchemeEditing = true;
    };

    $scope.doneColorSchemeEditing = function(item) {
        if(!item.colorSchemeEditing) return;

        item.color_scheme = item.color_scheme.name;

        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();
            $scope.changeProject();
            toaster.pop('success', 'Project Update', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Project Update Error', error);
        });

        item.colorSchemeEditing = false;
    };

    $scope.editLotRevision = function(item) {
        if(item.complete === true) {
            toaster.pop('warning', 'Cannot Change Revision',
                'Lot is completed.');
            return;
        }
        item.lotRevisionEditing = true;
    };

    $scope.doneLotRevisionEditing = function(item) {
        if(!item.lotRevisionEditing) return;
        item.active_options = [];

        //convert back from a revision object back to just a number
        item.revision = item.revision.number;

        //get the new bids based on the revision
        if(item.revision === $scope.totalRevisionLength) {
            ProjectBids.query({
                'project_id':$scope.selectedItem._id, 
                'trade': MeanUser.user.trade[0],
                'complete': false,
                'plan_code': item.plan }, function(bid_tasks) {
                bid_tasks = projectBidService.cleanBidRecordList(bid_tasks, item);

                //get the tasks associated with the lot/phase
                //and updated the project_bid_id
                ProjectTasks.query({
                    'project_id': $scope.selectedItem._id,
                    'lot': item.number, 'phase': item.phase }, function(project_tasks) {

                    _.each(bid_tasks, function(bid) {
                        var task = $filter('filter')(project_tasks, {'task_code': bid.task_code}, true);
                        if(task.length === 1) {
                            task[0].bid_hours = bid.totals.hours_allowed;
                            task[0].project_bid_id = bid._id;
                            task[0].$update();
                        } else if(task.length > 1) {
                            toaster.pop('error', 'Task Code Error', 
                                'Cannot complete operation. Contact Admin');
                            return;
                        }
                    });

                    var lot = $filter('filter')($scope.selectedItem.lots, {
                        'phase': item.phase, 'number': item.number }, true);
                    if(lot.length !== 1) {
                        toaster.pop('error', 'Issue Getting Lot', 'Contact Admin');
                        return;
                    }

                    var rev = $filter('filter')(lot[0].revisions, {'trade': $scope.user.trade[0]}, true);

                    if(rev.length === 0) {
                        lot[0].revisions.push({
                            'trade': $scope.user.trade[0],
                            'revision': item.revision
                        });
                    } else if(rev.length === 1) {
                        rev[0].revision = item.revision;
                    } else {
                        toaster.pop('error', 'Issue Getting Lot Revision', 'Contact Admin');
                        return;
                    }

                    $scope.selectedItem.$update(function(success) {
                        $scope.selectedItem = success;
                        $scope.normalizeLotRevisions();
                        //$scope.changeProject();
                        toaster.pop('success', 'Project Update', 'Database updated');
                    }, function(error) {
                        toaster.pop('error', 'Project Update Error', error);
                    });
                });
            });
        } else {
            ProjectBids.query({
                'project_id':$scope.selectedItem._id, 
                'trade': MeanUser.user.trade[0],
                'complete': false,
                'plan_code': item.plan,
                'revision': item.revision }, function(bid_tasks) {
                bid_tasks = projectBidService.cleanBidRecordList(bid_tasks, item);

                //get the tasks associated with the lot/phase
                //and updated the project_bid_id
                ProjectTasks.query({
                    'project_id': $scope.selectedItem._id,
                    'lot': item.number, 'phase': item.phase }, function(project_tasks) {

                    _.each(bid_tasks, function(bid) {
                        var task = $filter('filter')(project_tasks, {'task_code': bid.task_code}, true);
                        if(task.length === 1) {
                            task[0].bid_hours = bid.totals.hours_allowed;
                            task[0].project_bid_id = bid._id;
                            task[0].$update();
                        } else if(task.length > 1) {
                            toaster.pop('error', 'Task Code Error', 
                                'Cannot complete operation. Contact Admin');
                            return;
                        }
                    });

                    var lot = $filter('filter')($scope.selectedItem.lots, {
                        'phase': item.phase, 'number': item.number }, true);
                    if(lot.length !== 1) {
                        toaster.pop('error', 'Issue Getting Lot', 'Contact Admin');
                        return;
                    }

                    var rev = $filter('filter')(lot[0].revisions, {'trade': $scope.user.trade[0]}, true);

                    if(rev.length === 0) {
                        lot[0].revisions.push({
                            'trade': $scope.user.trade[0],
                            'revision': item.revision
                        });
                    } else if(rev.length === 1) {
                        rev[0].revision = item.revision;
                    } else {
                        toaster.pop('error', 'Issue Getting Lot Revision', 'Contact Admin');
                        return;
                    }

                    $scope.selectedItem.$update(function(success) {
                        $scope.selectedItem = success;
                        $scope.normalizeLotRevisions();
                        //$scope.changeProject();
                        toaster.pop('success', 'Project Update', 'Database updated');
                    }, function(error) {
                        toaster.pop('error', 'Project Update Error', error);
                    });
                });
            });
        }

        item.lotRevisionEditing = false;
    };

    $scope.completeLot = function(lot) {
        var tasks = $filter('filter')($scope.project_tasks, {
            'phase': lot.phase, 'lot': lot.number }, true);
        _.each(tasks, function(task) {
            task.complete = true;
            task.status = 'finished';
            task.date_completed = new Date();
            task.$update(function(success) {
                var idx = $scope.project_tasks.indexOf(success);
                if(idx !== -1) {
                    $scope.project_tasks.splice(idx, 1);
                } else {
                    toaster.pop('error', 'Project Task List Error', 
                        'Could not get the index of task to remove');
                }
            }, function(error) {
                toaster.pop('error', 'Project Task Error', error);
                return;
            });
        });

        lot.complete = true;
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            $scope.normalizeLotRevisions();
            lotService.complete(
                lot.number, 
                lot.phase,
                $scope.selectedItem.trade_code,
                $scope.selectedItem.company_code,
                $scope.selectedItem._id);
            toaster.pop('success', 'Database Updated', 'Lot successfully closed.');
        }, function(error) {
            toaster.pop('error', 'Database Update Error', error);
        });
    };

    $scope.completeLotOperation = function(lot) {
        ngDialog.openConfirm({
            template: 
                '<h2>Complete Lot Confirm</h2>' +
                '<p>This operation will close the lot ' + lot.number + '.</p>' +
                '<p>This will close down adding time and materials. It will also close down the ability to modify associated tasks. </p>' +
                '<p>Data on this lot will still be available in job costing and this lot can be opened back up at a later time. </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            $scope.completeLot(lot);
        }, function (value) {
            //Do something 
            console.log('in the do something section');
        });
    };

    $scope.reopenLot = function(lot) {
        ProjectTasks.query({'project_id': $scope.selectedItem._id,
            'complete': true,
            'company_code': userService.getCompanyCode(MeanUser.user.username),
            'trade_code': userService.getTradeCode(MeanUser.user.username),
            'phase': lot.phase,
            'lot': lot.number }, function(tasks) {
            // var tasks = $filter('filter')($scope.project_tasks, {
            //     'phase': lot.phase, 'lot': lot.number }, true);
            _.each(tasks, function(task) {
                task.complete = false;
                task.$update(function(success) {
                    $scope.project_tasks.push(success);
                }, function(error) {
                    toaster.pop('error', 'Task Save Error', error);
                });
            });

            lot.complete = false;
            $scope.selectedItem.$update(function(success) {
                $scope.selectedItem = success;
                $scope.normalizeLotRevisions();

                lotService.reopen(
                    lot.number, 
                    lot.phase,
                    $scope.selectedItem.trade_code,
                    $scope.selectedItem.company_code,
                    $scope.selectedItem._id);
                
                toaster.pop('success', 'Database Updated', 'Lot successfully reopend.');
            }, function(error) {
                toaster.pop('error', 'Database Update Error', error);
            });
        });
    };

    $scope.reopenLotOperation = function(lot) {
        ngDialog.openConfirm({
            template: 
                '<h2>Reopen Lot Confirm</h2>' +
                '<p>This will open the lot back up making it available to your users so they can add time and materials.</p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            $scope.reopenLot(lot);
        }, function (value) {
            //Do something 
            console.log('in the do something section');
        });
    };

    $scope.closeProject = function() {
        projectCompleteService.setComplete(true, $scope.selectedItem._id);
        $location.path('/');
    };

    $scope.removeActiveLotOption = function(lot, option) {
        var idx = lot.active_options.indexOf(option);
        lot.active_options.splice(idx, 1);
        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            toaster.pop('success', 'Database Updated');
        }, function(error) {
            toaster.pop('error', 'Database Update Error', error);
        });
    };

    $scope.doneRevisionEditing = function(trade_option, trade_total) {
        trade_total.revisionEdit = !trade_total.revisionEdit;
        trade_total.option_revision = parseInt(trade_total.option_revision);

        var option = $filter('filter')($scope.trade_options.options, {
            'number': trade_option.number}, true)[0];

        if(trade_total.option_revision < 1)
            trade_total.option_revision = 1;
        else if(trade_total.option_revision > option.revisions.length)
            trade_total.option_revision = option.revisions.length;

        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            toaster.pop('success', 'Database Updated');
        }, function(error) {
            toaster.pop('error', 'Database Update Error', error);
        });
    };

    $scope.doneTotalEditing = function(trade_option, trade_total) {
        trade_total.totalEdit = !trade_total.totalEdit;
        // trade_total.option_revision = parseInt(trade_total.option_revision);

        // var option = $filter('filter')($scope.trade_options.options, {
        //     'number': trade_option.number}, true)[0];

        // if(trade_total.option_revision < 1)
        //     trade_total.option_revision = 1;
        // else if(trade_total.option_revision > option.revisions.length)
        //     trade_total.option_revision = option.revisions.length;

        $scope.selectedItem.$update(function(success) {
            $scope.selectedItem = success;
            toaster.pop('success', 'Database Updated');
        }, function(error) {
            toaster.pop('error', 'Database Update Error', error);
        });
    };

    $scope.doneOptionRevisionEditing = function(trade_option, rev) {
        var option = $filter('filter')($scope.trade_options.options, {
            'number': trade_option.number}, true)[0];
        var idx = option.revisions.indexOf(rev);

        option.revisions[idx].number = rev.number;
        $scope.trade_options.$update(function(success) {
            $scope.trade_options = success;
            toaster.pop('success', 'Database Updated');
        }, function(error) {
            toaster.pop('error', 'Database Update Error', error);
        });
    };

    $scope.removeOptionRevision = function(trade_option, rev) {

        var option = $filter('filter')($scope.trade_options.options, {
            'number': trade_option.number}, true)[0];
        // var idx = option.revisions.indexOf(rev);
        // option.revisions.splice(idx, 1);
        _.remove(option.revisions, function(opt) {
            return opt._id === rev._id;
        });

        $scope.trade_options.$update(function(success) {
            $scope.trade_options = success;
            toaster.pop('success', 'Database Updated');
        }, function(error) {
            toaster.pop('error', 'Database Update Error', error);
        });
    };

    $scope.doneMainOptionRevisionEditing = function(trade_option) {
        trade_option.revision.number = parseInt(trade_option.revision.number);
        $scope.trade_options.$update(function(success) {
            $scope.trade_options = success;
            toaster.pop('success', 'Database Updated');
        }, function(error) {
            toaster.pop('error', 'Database Update Error', error);
        });
    };

    $scope.saveOption = function() {
        $scope.trade_options.$update(function(success) {
            $scope.trade_options = success;
            $scope.normalizeLotRevisions();

            $scope.buildCurrentOptions();
            $scope.matrix_values = [];

            $scope.matrix_values = optionPlanService.buildAndTotalPlans(
                $scope.trade_options.options,
                $scope.selectedItem.plan_codes, $scope.matrix_values, 
                $scope.trade_bids[0].bid_list, $scope.user.trade[0]);

            _.each($scope.ordered_lots, function(lot) {
                $scope.getOptionTotal(lot);
            })

            $rootScope.$broadcast('$updateOption', success);

            toaster.pop('success', 'Option Updated');
        }, function(error) {
            toaster.pop('error', 'Option Update Error', error);
        });
    };

    // $scope.ConvertReportToCSV = function(objArray, bidNote) {
    //     var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    //     console.log($scope.selectedItem);
    //     var str = $scope.selectedItem.name + ',Phase,';
    //     if(array.rows.length > 0) {
    //         _.each(array.rows[0].columns, function(col) {
    //             str += col.phase + ',';
    //         });
    //     }
    //     str += '\r\n';

    //     str += array.column_type + ',Lot,';
    //     if(array.rows.length > 0) {
    //         _.each(array.rows[0].columns, function(col) {
    //             str += col.lot + ',';
    //         });
    //     }
    //     str += '\r\n';

    //     str += ',Plan,';
    //     if(array.rows.length > 0) {
    //         _.each(array.rows[0].columns, function(col) {
    //             str += col.plan + ',';
    //         });
    //     }
    //     str += 'Total' + '\r\n';

    //     if(bidNote) {
    //         str += array.row_type + ',Note' + '\r\n';
    //     } else {
    //         str += array.row_type + '\r\n';
    //     }

    //     _.each(array.rows, function(row, ii) {
    //         str += row.name;
    //         if(bidNote && ii < array.rows.length-1) {
    //             str += ',' + row.note + ',';
    //         } else {
    //             str += ',,';
    //         }

    //         var row_total = 0;
    //         _.each(row.columns, function(col) {
    //             str += col.value + ',';
    //             row_total += col.value;
    //         });
    //         str += row_total + '\r\n';
    //     });

    //     return str;
    // };

    // $scope.exportReportFile = function(objArray, bidNote) {
    //     var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertReportToCSV(objArray, bidNote));
    //     var link = document.createElement('a');
    //     angular.element(link)
    //         .attr('href', dataUrl)
    //         .attr('download', 'report.csv') // Pretty much only works in chrome
    //     link.click();
    // };

    $scope.closeProjectOperation = function() {
        var projectId = angular.copy($scope.selectedItem._id);
        ngDialog.openConfirm({
            template: 
                '<h2>Close Project Confirm</h2>' +
                '<p>This will operation will close out ' + $scope.selectedItem.name + '.</p>' +
                '<p>All project data will be remain on the system but will not be available in any of the various project views.</p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            $scope.closeProject();
            console.log('********************');
            
            $http.post('/api/projectzip', { 'projectId': projectId, 'mainAccountId': $scope.main_account }).
            success(function (data, status, headers, config) {
                console.log('Zip created successfully.');
            }).
            error(function (data, status, headers, config) {
                console.log('There was an error with the zip');
            });
        }, function (value) {
            //Do something 
            console.log('in the do something section');
        });
    };

    $scope.syncPlansWithBid = function() {
        Bids.query({'project_id': $scope.selectedItem._id}, function(bids) {
            if(bids.length != 1) {
                console.log('we got problems finding the bid');
            } else {
                var bid = bids[0]
                var bid_codes = [];
                for(var i=0; i<bid.plan_codes.length; i++) {
                    bid_codes.push(bid.plan_codes[i].code);
                }

                console.log($scope.selectedItem.plan_codes);
                console.log($scope);
            }
        })
    };

    // $scope.buildReportData = function(bids) {
    //     var selected_bid = {};
    //     var bidNote = false;

    //     _.each(bids[0].bidding_trades, function(trade) {
    //         trade.bid_list = taskTotalsService.mergeBidAndTaskList(
    //             $scope.plans, 
    //             tradeCodeService.getCode($scope.user.trade[0]), 
    //             trade);

    //         taskTotalsService.getCalculations(
    //             trade.bid_list, 
    //             trade.costs);

    //         selected_bid = trade;
    //     });

    //     var report_lots = [];
    //     var report_plans = [];
    //     _.each($scope.ordered_lots, function(lotSelect) {
    //         if($scope.report_options.selected_lot[0] === 'All' &&
    //             $scope.report_options.selected_phase[0] === 'All') {
    //             report_lots.push({
    //                 'phase': lotSelect.phase,
    //                 'lot': lotSelect.number,
    //                 'plan': lotSelect.plan
    //             });
    //             if(report_plans.indexOf(lotSelect.plan) === -1)
    //               report_plans.push(lotSelect.plan);
    //         } else if($scope.report_options.selected_lot[0] === 'All' &&
    //             $scope.report_options.selected_phase.indexOf(lotSelect.phase) !== -1) {
    //             report_lots.push({
    //                 'phase': lotSelect.phase,
    //                 'lot': lotSelect.number,
    //                 'plan': lotSelect.plan
    //             });
    //             if(report_plans.indexOf(lotSelect.plan) === -1)
    //               report_plans.push(lotSelect.plan);
    //         } else if($scope.report_options.selected_lot.indexOf(lotSelect.number) !== -1) {
    //             report_lots.push({
    //                 'phase': lotSelect.phase,
    //                 'lot': lotSelect.number,
    //                 'plan': lotSelect.plan
    //             });
    //             if(report_plans.indexOf(lotSelect.plan) === -1)
    //               report_plans.push(lotSelect.plan);
    //         }
    //     });

    //     var planData = [];

    //     //materials that are not combined can cause problems with the
    //     //report data by adding duplicate columns.  per_entry is used
    //     //to make sure we just adjust value totals instead of dup columns.
    //     var per_entry = false;

    //     //build data for each plan involved in the report
    //     _.each(report_plans, function(planReport) {
    //         var datas = $filter('filter')(selected_bid.bid_list, {'plan': planReport}, true);

    //         if($scope.report_options.selected_row === "General Tasks") {
    //             if($scope.report_options.selected_column === "Bid Labor Hours") {
    //                 var bid_labor_hours = 0;
    //                 _.each(datas, function(item) {
    //                     bid_labor_hours += item.total_hours_allowed;
    //                     planData.push({
    //                         'plan': planReport,
    //                         'name': item.trade + item.task + ' - ' + item.name,                                    
    //                         'task': item.trade + item.task,
    //                         'value': item.total_hours_allowed
    //                     });
    //                 });
    //                 planData.row_total = bid_labor_hours;
    //             } else if($scope.report_options.selected_column === "Bid Direct Labor Cost") {
    //                 var total_current_net_pay = 0;
    //                 _.each(datas, function(item) {
    //                     total_current_net_pay += item.total_current_net_pay;
    //                     planData.push({
    //                         'plan': planReport,
    //                         'name': item.trade + item.task + ' - ' + item.name,
    //                         'task': item.trade + item.task,
    //                         'value': item.total_current_net_pay
    //                     });
    //                 });
    //                 planData.row_total = total_current_net_pay;
    //             } else if($scope.report_options.selected_column === "Bid Total Material Cost") {
    //                 var total_materials = 0;
    //                 _.each(datas, function(item) {
    //                     total_materials += item.total_materials;
    //                     planData.push({
    //                         'plan': planReport,
    //                         'name': item.trade + item.task + ' - ' + item.name,
    //                         'task': item.trade + item.task,
    //                         'value': item.total_materials
    //                     });
    //                 });
    //                 planData.row_total = total_materials;
    //             } else if($scope.report_options.selected_column === "Bid Total Equipment Cost") {
    //                 var total_equipment = 0;
    //                 _.each(datas, function(item) {
    //                     total_equipment += item.total_equipment;
    //                     planData.push({
    //                         'plan': planReport,
    //                         'name': item.trade + item.task + ' - ' + item.name,
    //                         'task': item.trade + item.task,
    //                         'value': item.total_equipment
    //                     });
    //                 });
    //                 planData.row_total = total_equipment;
    //             }
    //         } else if($scope.report_options.selected_row === "Subtasks") {
    //             bidNote = true;
    //             if($scope.report_options.selected_column === "Bid Labor Hours") {
    //                 var bid_labor_hours = 0;
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         bid_labor_hours += data.hours_allowed;
    //                         planData.push({
    //                             'plan': planReport,
    //                             'name': data.trade + data.task + ' - ' + data.name,
    //                             'note': data.note,
    //                             'task': data.trade + data.task,
    //                             'value': data.hours_allowed
    //                         });
    //                     });
    //                 });
    //                 planData.row_total = bid_labor_hours;
    //             } else if($scope.report_options.selected_column === "Bid Direct Labor Cost") {
    //                 var total_labor = 0;
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         total_labor += data.current_net_pay;
    //                         planData.push({
    //                             'plan': planReport,
    //                             'name': data.trade + data.task + ' - ' + data.name,
    //                             'note': data.note,
    //                             'task': data.trade + data.task,
    //                             'value': data.current_net_pay
    //                         });
    //                     });
    //                 });
    //                 planData.row_total = total_labor;
    //             } else if($scope.report_options.selected_column === "Bid Total Material Cost") {
    //                 var material_total = 0;
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         material_total += data.material_total;
    //                         planData.push({
    //                             'plan': planReport,
    //                             'name': data.trade + data.task + ' - ' + data.name,
    //                             'note': data.note,
    //                             'task': data.trade + data.task,
    //                             'value': data.material_total
    //                         });
    //                     });
    //                 });
    //                 planData.row_total = material_total;
    //             } else if($scope.report_options.selected_column === "Bid Total Equipment Cost") {
    //                 var equipment_total = 0;
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         equipment_total += data.equipment_total;
    //                         planData.push({
    //                             'plan': planReport,
    //                             'name': data.trade + data.task + ' - ' + data.name,
    //                             'note': data.note,
    //                             'task': data.trade + data.task,
    //                             'value': data.equipment_total
    //                         });
    //                     });
    //                 });
    //                 planData.row_total = equipment_total;
    //             }
    //         } else if($scope.report_options.selected_row === "Materials") {
    //             bidNote = true;
    //             if($scope.report_options.selected_column === "Bid Quantity (combined)") {
    //                 var quantity_total = 0;
    //                 var materials = [];
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         _.each(data.materials, function(material) {
    //                             material.bid_quantity = material.quantity;
    //                             material.note = (material.note)?material.note:'';
    //                             materials.push(material)
    //                         })
    //                     });
    //                 });

    //                 var new_consolidated_list = 
    //                     foremanPhaseService.combineSimilarNoteItems(materials);
    //                 //materials = foremanPhaseService.combineSimilarItems(materials);
    //                 _.each(new_consolidated_list, function(data) {
    //                     quantity_total += data.quantity;

    //                     planData.push({
    //                         'plan': planReport,
    //                         'name': data.name,
    //                         'note': data.note,
    //                         'color_code': data.color_code,
    //                         'value': data.quantity
    //                     });
    //                 });
    //                 planData.row_total = quantity_total;
    //             } else if($scope.report_options.selected_column === "Bid Quantity (per entry)") {
    //                 per_entry = true;
    //                 var quantity_total = 0;
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         _.each(data.materials, function(material) {
    //                             quantity_total += material.total;
    //                             material.note = (material.note)?material.note:'';

    //                             planData.push({
    //                                 'plan': planReport,
    //                                 'name': material.name,
    //                                 'note': material.note,
    //                                 'color_code': material.color_code,
    //                                 'value': material.quantity
    //                             });
    //                         })
    //                     });
    //                 });
    //                 planData.row_total = quantity_total;
    //             } else if($scope.report_options.selected_column === "Bid Cost (combined)") {
    //                 var total = 0;
    //                 var materials = [];
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         _.each(data.materials, function(material) {
    //                             material.bid_quantity = material.quantity;
    //                             material.note = (material.note)?material.note:'';
    //                             materials.push(material)
    //                         })
    //                     });
    //                 });
    //                 var new_consolidated_list = 
    //                     foremanPhaseService.combineSimilarNoteItems(materials);
                    
    //                 _.each(new_consolidated_list, function(data) {
    //                     total += data.total;

    //                     planData.push({
    //                         'plan': planReport,
    //                         'name': data.name,
    //                         'note': data.note,
    //                         'color_code': data.color_code,
    //                         'value': data.total
    //                     });
    //                 });
    //                 planData.row_total = total;
    //             } else if($scope.report_options.selected_column === "Bid Cost (per entry)") {
    //                 per_entry = true;
    //                 var mat_total = 0;
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         _.each(data.materials, function(material) {
    //                             var sales_tax = material.materials_subtotal *
    //                                 $scope.selectedItem.trades[0].company_factors.sales_tax;
    //                             material.total = material.materials_subtotal + sales_tax +
    //                                 material.materials_dev_subtotal;
    //                             mat_total += material.total;
    //                             material.note = (material.note)?material.note:'';

    //                             planData.push({
    //                                 'plan': planReport,
    //                                 'name': material.name,
    //                                 'note': material.note,
    //                                 'color_code': material.color_code,
    //                                 'value': material.total
    //                             });
    //                         })
    //                     });
    //                 });
    //                 planData.row_total = mat_total;
    //             }
    //         } else if($scope.report_options.selected_row === "Equipment") {
    //             bidNote = true;
    //             if($scope.report_options.selected_column === "Bid Quantity (combined)") {
    //                 var quantity_total = 0;
    //                 var equipment = [];
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         _.each(data.equipment, function(item) {
    //                             item.bid_quantity = item.quantity;
    //                             item.note = (item.note)?item.note:'';
    //                             equipment.push(item)
    //                         })
    //                     });
    //                 });

    //                 equipment = foremanPhaseService.combineSimilarItems(equipment);

    //                 var consolidated_list = 
    //                     foremanPhaseService.consolidateEquipmentOnForemanNotes(
    //                         equipment, $scope.selectedItem.trades[0].company_factors.equipment_tax);

    //                 //materials = foremanPhaseService.combineSimilarItems(materials);
    //                 _.each(consolidated_list, function(data) {
    //                     quantity_total += data.quantity;

    //                     planData.push({
    //                         'plan': planReport,
    //                         'name': data.name,
    //                         'note': data.note,
    //                         'value': data.quantity
    //                     });
    //                 });
    //                 planData.row_total = quantity_total;
    //             } else if($scope.report_options.selected_column === "Bid Quantity (per entry)") {
    //                 per_entry = true;
    //                 var quantity_total = 0;
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         _.each(data.equipment, function(equip) {
    //                             quantity_total += equip.total;
    //                             equip.note = (equip.note)?equip.note:'';

    //                             planData.push({
    //                                 'plan': planReport,
    //                                 'name': equip.name,
    //                                 'note': equip.note,
    //                                 'value': equip.quantity
    //                             });
    //                         })
    //                     });
    //                 });
    //                 planData.row_total = quantity_total;
    //             } else if($scope.report_options.selected_column === "Bid Cost (combined)") {
    //                 var total = 0;
    //                 var equipment = [];
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         _.each(data.equipment, function(equip) {
    //                             equip.bid_quantity = equip.quantity;
    //                             equip.note = (equip.note)?equip.note:'';
    //                             equipment.push(equip)
    //                         })
    //                     });
    //                 });
    //                 var new_consolidated_list = 
    //                     foremanPhaseService.combineSimilarNoteItems(equipment);
                    
    //                 _.each(new_consolidated_list, function(data) {
    //                     total += data.total;

    //                     planData.push({
    //                         'plan': planReport,
    //                         'name': data.name,
    //                         'note': data.note,
    //                         'value': data.total
    //                     });
    //                 });
    //                 planData.row_total = total;
    //             } else if($scope.report_options.selected_column === "Bid Cost (per entry)") {
    //                 per_entry = true;
    //                 var equip_total = 0;
    //                 _.each(datas, function(item) {
    //                     _.each(item.subtasks, function(data) {
    //                         _.each(data.equipment, function(equip) {
    //                             var sales_tax = equip.equipment_subtotal *
    //                                 $scope.selectedItem.trades[0].company_factors.equipment_tax;
    //                             equip.total = equip.equipment_subtotal + sales_tax +
    //                                 equip.equipment_dev_subtotal;
    //                             equip_total += equip.total;
    //                             equip.note = (equip.note)?equip.note:'';

    //                             planData.push({
    //                                 'plan': planReport,
    //                                 'name': equip.name,
    //                                 'note': equip.note,
    //                                 'value': equip.total
    //                             });
    //                         })
    //                     });
    //                 });
    //                 planData.row_total = equip_total;
    //             }
    //         }
    //     });

    //     var report = {
    //         'row_type': $scope.report_options.selected_row,
    //         'column_type': $scope.report_options.selected_column,
    //         'rows': []
    //     }

    //     var column_total = 0;
    //     var first = true;
    //     //build data table based on lots being used
    //     _.each(report_lots, function(lot, ii) {
    //         var itemDatas = $filter('filter')(planData, {'plan': lot.plan}, true);
            
    //         if(per_entry) {
    //             if(!report.rows.columns) report.rows.columns = [];

    //             _.each(itemDatas, function(data, idx) {
    //                 if(!report.rows.columns) report.rows.columns = [];

    //                 if(first) {
    //                     report.rows.push({
    //                         name: data.name,
    //                         note: data.note,
    //                         columns: [{
    //                             'lot': lot.lot,
    //                             'phase': lot.phase,
    //                             'plan': lot.plan,
    //                             'value': data.value
    //                         }]
    //                     })
    //                 } else {
    //                     report.rows[idx].columns.push({
    //                         'lot': lot.lot,
    //                         'phase': lot.phase,
    //                         'plan': lot.plan,
    //                         'value': data.value
    //                     })
    //                 }

    //                 column_total += data.value;
    //                 if(idx === itemDatas.length-1) {
    //                     var col_total = $filter('filter')(report.rows, {'name': 'Totals'}, true);

    //                     if(col_total.length === 0) {
    //                         report.rows.push({
    //                             'name': 'Totals',
    //                             'columns': [{
    //                                 'value': column_total
    //                             }]
    //                         });
    //                     } else if(col_total.length === 1) {
    //                         col_total[0].columns.push({
    //                             'value': column_total
    //                         })
    //                     }

    //                     column_total = 0;
    //                 }
    //             });

    //             first = false;
    //         } else {
    //             _.each(itemDatas, function(data, idx) {
    //                 var inlist = [];
    //                 if(bidNote) {
    //                     inlist = $filter('filter')(report.rows, {
    //                         'name': data.name, 'note': data.note}, true);
    //                 } else {
    //                     inlist = $filter('filter')(report.rows, {'name': data.name}, true);
    //                 }

    //                 if(inlist.length === 0) {
    //                     if(!report.rows.columns) report.rows.columns = [];

    //                     report.rows.push({
    //                         name: data.name,
    //                         note: data.note,
    //                         columns: [{
    //                             'lot': lot.lot,
    //                             'phase': lot.phase,
    //                             'plan': lot.plan,
    //                             'value': data.value
    //                         }]
    //                     })
    //                 } else if(inlist.length === 1) {
    //                     // if(per_entry) {
    //                     //     var found = $filter('filter')(inlist[0].columns, {
    //                     //         'lot': lot.lot, 'phase': lot.phase }, true);

    //                     //     if(found.length === 0) {
    //                     //         inlist[0].columns.push({
    //                     //             'lot': lot.lot,
    //                     //             'phase': lot.phase,
    //                     //             'plan': lot.plan,
    //                     //             'value': data.value
    //                     //         })
    //                     //     } else if(found.length === 1) {
    //                     //         found[0].value += data.value;
    //                     //     } else {
    //                     //         console.log('this should not be happening');
    //                     //     }
    //                     // } else {
    //                         inlist[0].columns.push({
    //                             'lot': lot.lot,
    //                             'phase': lot.phase,
    //                             'plan': lot.plan,
    //                             'value': data.value
    //                         })
    //                     //}
    //                 } else {
    //                     toaster.pop('Report Error', 'Something is wrong');
    //                     return;
    //                 }

    //                 column_total += data.value;
    //                 if(idx === itemDatas.length-1) {
    //                     var col_total = $filter('filter')(report.rows, {'name': 'Totals'}, true);

    //                     if(col_total.length === 0) {
    //                         report.rows.push({
    //                             'name': 'Totals',
    //                             'columns': [{
    //                                 'value': column_total
    //                             }]
    //                         });
    //                     } else if(col_total.length === 1) {
    //                         col_total[0].columns.push({
    //                             'value': column_total
    //                         })
    //                     }

    //                     column_total = 0;
    //                 }
    //             })
    //         }
    //         // _.each(itemDatas, function(data, idx) {
    //         //     var inlist = [];
    //         //     if(bidNote) {
    //         //         inlist = $filter('filter')(report.rows, {
    //         //             'name': data.name, 'note': data.note}, true);
    //         //     } else {
    //         //         inlist = $filter('filter')(report.rows, {'name': data.name}, true);
    //         //     }

    //         //     if(inlist.length === 0) {
    //         //         if(!report.rows.columns) report.rows.columns = [];

    //         //         report.rows.push({
    //         //             name: data.name,
    //         //             note: data.note,
    //         //             columns: [{
    //         //                 'lot': lot.lot,
    //         //                 'phase': lot.phase,
    //         //                 'plan': lot.plan,
    //         //                 'value': data.value
    //         //             }]
    //         //         })
    //         //     } else if(inlist.length === 1) {
    //         //         // if(per_entry) {
    //         //         //     var found = $filter('filter')(inlist[0].columns, {
    //         //         //         'lot': lot.lot, 'phase': lot.phase }, true);

    //         //         //     if(found.length === 0) {
    //         //         //         inlist[0].columns.push({
    //         //         //             'lot': lot.lot,
    //         //         //             'phase': lot.phase,
    //         //         //             'plan': lot.plan,
    //         //         //             'value': data.value
    //         //         //         })
    //         //         //     } else if(found.length === 1) {
    //         //         //         found[0].value += data.value;
    //         //         //     } else {
    //         //         //         console.log('this should not be happening');
    //         //         //     }
    //         //         // } else {
    //         //             inlist[0].columns.push({
    //         //                 'lot': lot.lot,
    //         //                 'phase': lot.phase,
    //         //                 'plan': lot.plan,
    //         //                 'value': data.value
    //         //             })
    //         //         //}
    //         //     } else {
    //         //         toaster.pop('Report Error', 'Something is wrong');
    //         //         return;
    //         //     }

    //         //     column_total += data.value;
    //         //     if(idx === itemDatas.length-1) {
    //         //         var col_total = $filter('filter')(report.rows, {'name': 'Totals'}, true);

    //         //         if(col_total.length === 0) {
    //         //             report.rows.push({
    //         //                 'name': 'Totals',
    //         //                 'columns': [{
    //         //                     'value': column_total
    //         //                 }]
    //         //             });
    //         //         } else if(col_total.length === 1) {
    //         //             col_total[0].columns.push({
    //         //                 'value': column_total
    //         //             })
    //         //         }

    //         //         column_total = 0;
    //         //     }
    //         // })
    //     });

    //     console.log(report);
    //     $scope.exportReportFile(report, bidNote);
    // };

    // $scope.runReportOperation = function (item) {
    //     var phases = [];
    //     var ordered_lots = [];
    //     _.each($scope.ordered_lots, function(lot) {
    //         if(phases.indexOf(lot.phase) === -1) {
    //             phases.push(lot.phase);
    //         }
    //         ordered_lots.push(lot.number);
    //     });

    //     phases.unshift('All');
    //     ordered_lots.unshift('All');

    //     $scope.report_options = {
    //         'phases': phases,
    //         'lots': ordered_lots,
    //         'selected_phase': [phases[0]],
    //         'selected_lot': [ordered_lots[0]],
    //         'project_id': $scope.selectedItem._id,
    //         'rows': ['General Tasks', 'Subtasks', 'Materials', 'Equipment'],
    //         'task_coloumns': ['Bid Labor Hours', 'Bid Direct Labor Cost', 'Bid Total Material Cost', 'Bid Total Equipment Cost'],
    //         'material_columns': ['Bid Quantity (combined)', 'Bid Quantity (per entry)', 'Bid Cost (combined)', 'Bid Cost (per entry)']
    //     };

    //     ngDialog.openConfirm({
    //         template: 'projects/views/project/report.html',
    //         scope: $scope,
    //         className: 'ngdialog-theme-default'
    //     }).then(function (value) {
    //         Bids.query({'project_id': $scope.report_options.project_id}, function(bids) {
    //             if(bids.length != 1) {
    //                 if($scope.trade_options) {
    //                     Bids.query({'_id': $scope.trade_options.bid_id}, function(bids) {
    //                         if(bids.length != 1) {
    //                             toaster.pop('Bid Error', 'Could not find bid');
    //                         } else if(bids[0].bidding_trades.length !== 1) {
    //                             toaster.pop('Bid Error', 'Too many bid trades');
    //                         } else {
    //                             $scope.buildReportData(bids);
    //                         }
    //                     });
    //                 } else {
    //                     toaster.pop('Bid Error', 'Could not find bid or associated options');
    //                 }
    //             } else if(bids[0].bidding_trades.length !== 1) {
    //                 toaster.pop('Bid Error', 'Too many bid trades');
    //             } else {
    //                 $scope.buildReportData(bids);
    //             }
    //         });
    //     }, function (value) {
    //         //Do something
    //         console.log('in the do something section');
    //     });
    // };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectAdmin.js